
/* ===== Loading Namespace ===== */
const Loading = (() => {
  /* ===== Local ===== */
  // Elems
  const loadingBottom = document.querySelector(".loading--bottom");
  const loadingTop = document.querySelector(".loading--top");
  const loadMoreBtnPrev = document.querySelector(".load-more-btn--prev");
  const loadMoreBtnNext = document.querySelector(".load-more-btn--next");

  /* ===== Functions ===== */
  // Bottom Loading
  function HideBottom() {
    loadingBottom.classList.add("sk-hidden");
  }

  function ShowBottom() {
    loadingBottom.classList.remove("sk-hidden");
  }

  // Top Loading
  function HideTop() {
    loadingTop.classList.add("sk-hidden");
  }

  function ShowTop() {
    loadingTop.classList.remove("sk-hidden");
  }

  // State
  function IsLoading() {
    return loadingTop.classList.contains("sk-hidden") === false || loadingBottom.classList.contains("sk-hidden") === false;
  }

  /* ===== Freeze ===== */
  return Object.freeze({
    ShowTop,
    HideTop,
    ShowBottom,
    HideBottom,
    IsLoading,
  })
})();

// Loading text/icon
let loadingSpinner = document.querySelector('.loading')
let productGrid = document.querySelector('.product-grid')
async function pageLoading() {
  // loadingSpinner.style.display = 'block'
  Loading.ShowTop();
}
async function donePageLoading() {
  // loadingSpinner.style.display = 'none'
  Loading.HideTop();
}

// Activates notify me modal
async function showNotifyMeModal(e) {
  e.preventDefault();

  e.currentTarget.innerText = "NOTIFY ME";

  // Init product data
  let productId = e.currentTarget.dataset.productId;
  let variantId = e.currentTarget.dataset.variantId;
  let du = `${document.body.getAttribute("data-url")}${e.currentTarget.dataset.url}`;

  let params = {
    empi: productId,
    epi: variantId,
    du: du
  };

  // Shows notify me
  _swat.getProductDetails(params, function(productJSON) {
    productJSON.variants.forEach(function(v) {
      if (v.id == variantId) {
        params.pr = SwymUtils.formatProductPrice(v.price);
        params.iu = productJSON.featured_image;
        params.et = 8;
        _swat.addToWatchList(e, params, function(e) {
          console.log("Subscribed to product!", e);
        }); // Shows Subscribe me.
        return;
      }

    });
  });
}

// Selects a sold out product
function soldOutProductDesktopSelect(e) {

  e = e.currentTarget;
  closeResetScrollers()
  let button = e.closest('.variant-scroller').querySelector('.add-to-cart-btn')
  let variantImgSrc = e.dataset.variantImg
  let variantImg = e.closest('.product-card').querySelector('.variant-image')

  e.closest('.variant-scroller').classList.add('product-selected')
  e.classList.add('product-selected')

  button.classList.remove('inactive')
  button.dataset.productId = e.dataset.productId;
  button.dataset.variantId = e.dataset.variantId
  button.dataset.quantity = e.dataset.quantity

  // data for notification popup
  let variantTitle = e.dataset.variantTitle;
  let imageSrc = e.dataset.src;
  let url = e.dataset.url;
  let notifComparePrice = e.dataset.notifComparePrice;
  let notifPrice = e.dataset.notifPrice;
  let quantityMax = e.dataset.quantityMax;
  let isBogo = e.dataset.isBogo;

  button.dataset.url = url;
  button.dataset.src = imageSrc;
  button.dataset.variantTitle = variantTitle;
  button.dataset.notifComparePrice = notifComparePrice;
  button.dataset.notifPrice = notifPrice;
  button.dataset.quantityMax = quantityMax;
  button.dataset.isBogo = isBogo;

  if (e.dataset.variantPrice === undefined) {
    return;
  }

  button.addEventListener("click", showNotifyMeModal);
  button.innerHTML = "NOTIFY ME"

  if (variantImgSrc) {
    variantImg.setAttribute('src', variantImgSrc)
    variantImg.classList.add('active')
  }
}

function soldOutProductMobileSelect(e) {
  e = e.currentTarget;
  e.closest('.variant-picker-main-options').classList.add('variant-selected')
  e.classList.add('selected-variant')

  let productId = e.dataset.productId
  let variantId = e.dataset.variantId
  let quantity = e.dataset.quantity
  let price = e.dataset.variantPrice
  let originalPrice = e.dataset.comparePrice

  let addToCartBtn = e.closest('.variant-picker-main').querySelector('.add-to-cart-btn');

  addToCartBtn.classList.remove('inactive')
  addToCartBtn.dataset.productId = productId
  addToCartBtn.dataset.variantId = variantId
  addToCartBtn.dataset.quantity = quantity

  // data for notification popup
  let variantTitle = e.dataset.variantTitle;
  let imageSrc = e.dataset.src;
  let url = e.dataset.url;
  let notifComparePrice = e.dataset.notifComparePrice;
  let notifPrice = e.dataset.notifPrice;
  let quantityMax = e.dataset.quantityMax;
  let isBogo = e.dataset.isBogo;

  addToCartBtn.dataset.url = url;
  addToCartBtn.dataset.src = imageSrc;
  addToCartBtn.dataset.variantTitle = variantTitle;
  addToCartBtn.dataset.notifComparePrice = notifComparePrice;
  addToCartBtn.dataset.notifPrice = notifPrice;
  addToCartBtn.dataset.quantityMax = quantityMax;
  addToCartBtn.dataset.isBogo = isBogo;

  addToCartBtn.addEventListener("click", showNotifyMeModal);
  addToCartBtn.innerHTML = "NOTIFY ME"
}

// Adds click events to any sold out button
function initSoldOutMobileBtns() {
  // desktop
  Array.from(document.querySelectorAll(".variant-scroller-option.unavailable")).forEach(btn => {
    btn.addEventListener("click", soldOutProductDesktopSelect);
  });

  // mobile
  Array.from(document.querySelectorAll(".variant-picker-main-option.unavailable")).forEach(btn => {
    btn.addEventListener("click", soldOutProductMobileSelect);
  });
}

// Filter variables
let activeFilters = []
let removeFilterTemplate = ""
let products //moved products' defining to each add/remove filter function because http request added products dont get affected
const startProductCount = document.querySelectorAll('sub')[0].innerHTML

// Endless scroll variables
// let url = window.location.pathname
let urlSearch = window.location.search
let requestUrl = ''
let pageNum = 2
// let maxPages = parseInt(document.querySelector('.pagination').dataset.collectionPages)
// let maxPages = 3; //placeholder for testing
let sortType = ''
let isLoadingPage = false
let allowLoadReviews = true
let allowReviewsTimeout = undefined;

/////// Collection Brand Filtering
// function to update filtered collection item count
function updateProductCount() {
  let productCount = document.querySelectorAll('.product-card:not([style="display: none;"])').length

  if (productCount <= 0 || activeFilters.length <= 0) {
    document.querySelectorAll('sub')[0].innerHTML = startProductCount
  } else {
    document.querySelectorAll('sub')[0].innerHTML = productCount
  }
}

/////// Collection Pagination / Endless Scroll
if (urlSearch.includes('?page=')){
  pageNum = parseInt(urlSearch.slice(urlSearch.indexOf('?page=') + 6, 7))
}
// Load products from ONE page
async function loadOnePage() {
  isLoadingPage = true
  if (pageNum < maxPages) {
    pageLoading()
  } else if (pageNum > maxPages) {
    return;
  }

  if (urlSearch.includes('sort_by=')) {
      sortType = urlSearch.slice(urlSearch.indexOf('sort_by='))
      requestUrl = `${url}?page=${pageNum}&${sortType}`
  } else {
    requestUrl = `${url}?page=${pageNum}`
  }
  fetch(requestUrl)
    .then(response => response.text())
    .then(response => {
      let pageContent = document.createElement('div')
      pageContent.innerHTML = response
      let addedContent = pageContent.querySelectorAll('.product-card')

      addedContent.forEach(element => {
        document.querySelector('.product-grid').append(element)
      })
      if (pageNum <= maxPages) {
        console.log(`Page ${pageNum} of ${maxPages} loaded!`)
      }
      pageNum++
      isLoadingPage = false
      // resizeVariants()
      donePageLoading()
      initCollectionProducts();
    })
    .catch(res => {
      return;
    })
}

function openVariantOverlay(e) {
  e = e.currentTarget;
  if (window.innerWidth > 980) {
    if (!e.classList.contains('overlay-active')) {
      closeAllOverlays()

      e.classList.add('overlay-active')
    }
  }
}

// general function to close all overlays/scrollers
function closeAllOverlays() {
  let products = Array.from(document.querySelectorAll('.product-card.overlay-active'))
  let scrollers = Array.from(document.querySelectorAll('.variant-scroller.active'))
  for (let i = 0; i < products.length; i++) {
    products[i].classList.remove('overlay-active')
  }
  scrollers.forEach(item => {
    item.classList.remove('active');
  });
}
// Opens scrollers
function openScroller(e) {
  e = e.currentTarget;
  closeAllScrollers(e)
  let scroller = e.closest('.product-card').querySelector('.variant-scroller')
  scroller.classList.add('active')
}
function closeAllScrollers(e) {
  let scrollers = document.querySelectorAll('.variant-scroller')
  scrollers.forEach(item => {
    if (e != item) {
      item.classList.remove('active')
      item.classList.remove('product-selected')
    }
  })
  document.querySelectorAll('.variant-image').forEach(img => {
    if (img.src != '' || img.src != undefined || img.src != null) {
      img.classList.remove('active')
      img.src = ''
    }
  })
}

/// Lazily loads images -- definitely reusable for other product images
async function lazyLoad() {
  let lazyImgs = document.querySelectorAll('.lazy')

  lazyImgs.forEach(img => {
    img.setAttribute('src', img.getAttribute('data-src'))
    img.onload = () => {
      img.classList.remove('lazy')
    }
  });
}

// Resize variant overlay thingies
function resizeVariants() {
  if (document.querySelectorAll('.product-card')[0]) {
    let oneProduct = document.querySelectorAll('.product-card')[0]
    let overlayBaseProducts = document.querySelectorAll('.overlay-product')
    let variants = document.querySelectorAll('.variant')
    let height, width

    height = oneProduct.clientHeight
    width = oneProduct.clientWidth

    variants.forEach(element => {
      element.style.width = (width) + "px"
    });
    overlayBaseProducts.forEach(element => {
      element.style.width = (width) + "px"
    });
  }
}

// Select Product in Scroller
function selectProduct(e) {
  e = e.currentTarget;
  closeResetScrollers()
  let button = e.closest('.variant-scroller').querySelector('.add-to-cart-btn')
  let variantImgSrc = e.dataset.variantImg
  let variantImg = e.closest('.product-card').querySelector('.variant-image')

  e.closest('.variant-scroller').classList.add('product-selected')
  e.classList.add('product-selected')

  button.classList.remove('inactive')
  button.dataset.variantId = e.dataset.variantId
  button.dataset.quantity = e.dataset.quantity

  // data for notification popup
  let variantTitle = e.dataset.variantTitle;
  let imageSrc = e.dataset.src;
  let url = e.dataset.url;
  let notifComparePrice = e.dataset.notifComparePrice;
  let notifPrice = e.dataset.notifPrice;
  let quantityMax = e.dataset.quantityMax;
  let isBogo = e.dataset.isBogo;

  button.dataset.url = url;
  button.dataset.src = imageSrc;
  button.dataset.variantTitle = variantTitle;
  button.dataset.notifComparePrice = notifComparePrice;
  button.dataset.notifPrice = notifPrice;
  button.dataset.quantityMax = quantityMax;
  button.dataset.isBogo = isBogo;

  if (e.dataset.variantPrice === undefined) {
    return;
  }

  if (e.dataset.variantOriginalPrice) {
    button.innerHTML = `ADD ${e.dataset.variantPrice}&nbsp;<span class="strikethrough">${e.dataset.variantOriginalPrice}</span>`
  } else {
    button.innerHTML = `ADD ${e.dataset.variantPrice}`
  }

  if (variantImgSrc) {
    variantImg.setAttribute('src', variantImgSrc)
    variantImg.classList.add('active')
  }
}
// Closes and resets Scrollers
function closeResetScrollers() {
  document.querySelectorAll('.variant-scroller').forEach(item => {
    item.classList.remove('product-selected')
    item.lastElementChild.classList.add('inactive')
  })
  document.querySelectorAll('.variant-scroller-option').forEach(item => {
    item.classList.remove('product-selected')
  })
  document.querySelectorAll('.variant-image').forEach(img => {
    if (img.src != '' || img.src != undefined || img.src != null) {
      img.classList.remove('active')
      img.src = ''
    }
  })

  document.querySelectorAll('.variant-scroller .add-to-cart-btn').forEach(btn => {
    btn.removeEventListener("click", showNotifyMeModal);
  });
}

// Async Add to Cart -- temporary
async function addToCart(e) {
  e = e.currentTarget;
  let variantId, quantity

  variantId = e.dataset.variantId
  quantity =  e.dataset.quantity

  // setup data for notification popup
  const comparePriceText = e.dataset.notifComparePrice;
  const priceText = e.dataset.notifPrice;
  const url = e.dataset.url;
  const imageSrc = e.dataset.src;
  const variantTitle = e.dataset.variantTitle;
  const quantityMax = e.dataset.quantityMax;

  // bogo
  const isBogo = e.dataset.isBogo === "true" ? true : false;

  // change quantity if bogo
  // if (isBogo) {
  //   let quantityDouble = quantity * 2;
  //   let policyDeny = quantityMax === -1 ? false : true;
  //   let remainingCount = quantityMax;
  //   let cartCount = 0;

  //   // get quantity in cart
  //   document.querySelectorAll("#cart-side .cart-body .line-items-list .line-item").forEach(function (item) {
  //     if (item.getAttribute("data-vid") === variantId) {
  //       if (item.getAttribute("data-is-bogo-side") === "false") {
  //         const cartQuantity = parseInt(item.querySelector(".line-item__col.line-item__col--quantity input[type='number'].quantity-value").value);
  //         cartCount += cartQuantity;
  //       } else if (item.getAttribute("data-is-bogo-side") === "true") {
  //         const cartQuantity = parseInt(item.querySelector(".line-item__col.line-item__col--price .line-item__discount-free").innerText.split(" ")[0]);
  //         cartCount += cartQuantity;
  //       }
  //     }
  //   });

  //   if (remainingCount - cartCount < quantityDouble && policyDeny) {
  //     quantity = quantity;
  //   } else {
  //     quantity = quantityDouble;
  //   }
  // }

  // Show loading
  if (e.classList.contains("add-to-cart-btn")) {
    e.innerText = "ADDING..";
  }

  //adds to cart, refreshes the sidecart and shows the sidecart
  Global.Cart.add({ id: variantId, quantity: quantity })
  .then(res => {
    const quantityInCart = res.items[0].quantity;
    const isDesktop = window.matchMedia("only screen and (min-width: 768px)").matches;

    Global.SideCart.refresh()

    if (isDesktop) {
      // Global.SideCart.show();
    } else {
      NotificationPopups.show({
          comparePrice: comparePriceText,
          link: url,
          price: priceText,
          quantity: quantity,
          src: imageSrc,
          variantTitle: variantTitle,
          quantityCart: quantityInCart,
          quantityMax: quantityMax,
          variantId: variantId,
      });
    }

    // End loading
    if (e.classList.contains("add-to-cart-btn")) {
      e.innerText = "ADD TO CART";
    }

    closeMobileVariantSelector({currentTarget: e})
  })
  .catch(e => {
    return;
  })
}

////Notify Me Modal
// Opens Notify Me Modal
function openNotifyMeModal(e) {
  e = e.currentTarget;
  // let variantId = e.dataset.variantId
  // console.log(`Added to email list for product ${variantId}!`)

  //find notify-modal
  let childNodes = e.closest('.product-card').children

  for (let i = 0; i < childNodes.length; i++) {
    if (childNodes[i].classList.contains('notify-modal')) {
      childNodes[i].classList.add('active')
    }
  }
}
// Closes Notify Me Modal
function closeNotifyMeModal(e) {
  e = e.currentTarget;
  e.closest('.notify-modal').classList.remove('active')
}
// Adds user's email to email listing
function addEmailNotify(e) {
  e = e.currentTarget;
  let productId = e.dataset.productId
  let email = e.previousElementSibling.value
  // add Regex for email + send to klaviyo
  console.log(`User email: ${email} was added to product '${productId}' email subscription or whatever!`)
}

// load Yotpo reviews for each product
async function loadReviews() {
  let products = Array.from(document.querySelectorAll('.product-card .yotpo.bottomLine'));

  if (products.length <= 0) {
    return;
  }

  if (allowLoadReviews) {
    for (i = 0; i < products.length; i++) {
      let appKey = products[i].dataset.appkey
      let productId = products[i].dataset.productId
      let requestUrl = `https://api.yotpo.com/products/${appKey}/${productId}/bottomline`

      const options = {
        method: 'GET',
        headers: {Accept: 'application/json', 'Content-Type': 'application/json'}
      }

      let reviewStarsContainer = undefined;

      if (products[i].closest('.product-card').querySelector(".product-card__bottom .no-reviews")) {
        reviewStarsContainer = products[i].closest('.product-card').querySelector(".product-card__bottom .no-reviews");
      }

      if (reviewStarsContainer) {
        const response = fetch(requestUrl, options)
        .then(res => res.json())
        .then(res => {
          let totalReviews = res.response.bottomline.total_reviews;
          let averageScore = res.response.bottomline.average_score;

          if (products[i]) {
            products[i].classList.remove('bottomLine')
          }

          if (totalReviews > 0) {
            const noStarHtml = document.createElement("span");
            noStarHtml.classList.add("review-star");
            noStarHtml.classList.add("review-star--empty");

            const halfStarHtml = document.createElement("span");
            halfStarHtml.classList.add("review-star");
            halfStarHtml.classList.add("review-star--half");

            const fullStarHtml = document.createElement("span");
            fullStarHtml.classList.add("review-star");
            fullStarHtml.classList.add("review-star--full");

            // Create stars based on reviews
            let reviewStars = [];
            let reviewStarsElem = document.createElement("div");
            reviewStarsElem.classList.add("review-stars");

            if (averageScore > 4.7) {
              // 5 stars
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(fullStarHtml.cloneNode());
            } else if (averageScore > 4.2) {
              // 4.5 stars
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(halfStarHtml.cloneNode());
            } else if (averageScore > 3.7) {
              // 4 stars
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
            } else if (averageScore > 3.2) {
              // 3.5 stars
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(halfStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
            } else if (averageScore > 2.7) {
              // 3 stars
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
            } else if (averageScore > 2.2) {
              // 2.5 stars
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(halfStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
            } else if (averageScore > 1.7) {
              // 2 stars
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
            } else if (averageScore > 1.2) {
              // 1.5 stars
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(halfStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
            } else if (averageScore > 0.7) {
              // 1 stars
              reviewStars.push(fullStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
            } else if (averageScore > 0.2) {
              // 0.5 stars
              reviewStars.push(halfStarHtml);
              reviewStars.push(noStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
            } else {
              // 0 stars
              reviewStars.push(noStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
              reviewStars.push(noStarHtml.cloneNode());
            }

            reviewStars.forEach(star => reviewStarsElem.appendChild(star));

            // Add review count
            let reviewCountElem = document.createElement("span");
            reviewCountElem.classList.add("review-count");

            if (totalReviews > 99) {
              totalReviews = "99+";
            }

            reviewCountElem.innerText = `(${totalReviews})`;

            // Populate
            reviewStarsContainer.innerHTML = "";
            reviewStarsContainer.appendChild(reviewStarsElem);
            reviewStarsContainer.appendChild(reviewCountElem);

            reviewStarsContainer.classList.remove('no-reviews');
            reviewStarsContainer.closest('.product-card').classList.add("product-card--review-found");
          }
        })
        .catch(res => {
          allowLoadReviews = false;
          // throw Error(res.statusText)
          // break
          // return // if there is no HTTP 200 response, throws an error, breaks the product review fetch loop then exits the function
        });

        if (allowLoadReviews === false) {
          console.log("Not currently loading reviews.");
          break;
        }
      }
    }
  } else {
    console.log("Not currently loading reviews.");

    if (allowReviewsTimeout) {
      return;
    }

    allowReviewsTimeout = setTimeout(() => {
      allowLoadReviews = true;
      clearTimeout(allowReviewsTimeout);
    }, 5000)
  }
}

/// Misc Functions
//lazy loads images when page is loaded, resizes images on load too, just in case
document.addEventListener('DOMContentLoaded', () => {
  loadReviews()
})

/**
 * ===========================
 * New Collection Product Card
 * ===========================
 */
/*
    Checks Daylight Savings
*/
function isDST(d) {
  let jan = new Date(d.getFullYear(), 0, 1).getTimezoneOffset();
  let jul = new Date(d.getFullYear(), 6, 1).getTimezoneOffset();
  return Math.max(jan, jul) !== d.getTimezoneOffset();
}

/*
    Checks leap year
*/
function leapYear(year) {
  return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
}

const ProductCards = (() => {
  function initEvents() {
    let allProductCards = Array.from(document.querySelectorAll(".product-card"));

    allProductCards.forEach(card => {
      let ctaBtn = card.querySelector(".add-to-cart-btn");

      if (ctaBtn) {
        if (ctaBtn.classList.contains("add-to-cart-btn--add")) {
          ctaBtn.addEventListener("click", addToCartClick);
        } else if (ctaBtn.classList.contains("add-to-cart-btn--more")) {
          ctaBtn.addEventListener("click", seeMoreClick);
        } else if (ctaBtn.classList.contains("add-to-cart-btn--notify")) {
          ctaBtn.addEventListener("click", notifyClick);
        }
      }

      // Check for data time badge
      let dataTimeBadges = Array.from(card.querySelectorAll(".footer-badges .tag-badge[data-time]"));

      if (dataTimeBadges.length > 0) {
        dataTimeBadges.forEach(badge => {
          // Get date
          let customBadgeTime = badge.getAttribute("data-time");
          let customBadgeTimeEnd = "";
          let customBadgeTimeActive = false;
          let customBadgeTimeStart = false;

          // Format: mm-dd
          let month = parseInt(customBadgeTime.split("-")[0]);
          let day = parseInt(customBadgeTime.split("-")[1]);
          let year = new Date().getFullYear();

          let nextMonth = "";
          let nextDay = "";
          let nextYear = "";

          // Get month
          switch (month) {
            case 1:
              month = "Jan";

              if (day === 31) {
                nextDay = 1;
                nextMonth = "Feb";
                nextYear = year;
              } else {
                nextDay = parseInt(day) + 1;
                nextMonth = month;
                nextYear = year;
              }
              break;
            case 2:
              month = "Feb";

              if (day === 29 && leapYear(year)) {
                nextDay = 1;
                nextMonth = "Mar";
                nextYear = year;
              } else if (day === 28 && !leapYear(year)) {
                nextDay = 1;
                nextMonth = "Mar";
                nextYear = year;
              } else {
                nextDay = parseInt(day) + 1;
                nextMonth = month;
                nextYear = year;
              }
              break;
            case 3:
              month = "Mar";

              if (day === 31) {
                nextDay = 1;
                nextMonth = "Apr";
                nextYear = year;
              } else {
                nextDay = parseInt(day) + 1;
                nextMonth = month;
                nextYear = year;
              }
              break;
            case 4:
              month = "Apr";

              if (day === 30) {
                nextDay = 1;
                nextMonth = "May";
                nextYear = year;
              } else {
                nextDay = parseInt(day) + 1;
                nextMonth = month;
                nextYear = year;
              }
              break;
            case 5:
              month = "May";

              if (day === 31) {
                nextDay = 1;
                nextMonth = "Jun";
                nextYear = year;
              } else {
                nextDay = parseInt(day) + 1;
                nextMonth = month;
                nextYear = year;
              }
              break;
            case 6:
              month = "Jun";

              if (day === 30) {
                nextDay = 1;
                nextMonth = "Jul";
                nextYear = year;
              } else {
                nextDay = parseInt(day) + 1;
                nextMonth = month;
                nextYear = year;
              }
              break;
            case 7:
              month = "Jul";

              if (day === 31) {
                nextDay = 1;
                nextMonth = "Aug";
                nextYear = year;
              } else {
                nextDay = parseInt(day) + 1;
                nextMonth = month;
                nextYear = year;
              }
              break;
            case 8:
              month = "Aug";

              if (day === 31) {
                nextDay = 1;
                nextMonth = "Sep";
                nextYear = year;
              } else {
                nextDay = parseInt(day) + 1;
                nextMonth = month;
                nextYear = year;
              }
              break;
            case 9:
              month = "Sep";

              if (day === 30) {
                nextDay = 1;
                nextMonth = "Oct";
                nextYear = year;
              } else {
                nextDay = parseInt(day) + 1;
                nextMonth = month;
                nextYear = year;
              }
              break;
            case 10:
              month = "Oct";

              if (day === 31) {
                nextDay = 1;
                nextMonth = "Nov";
                nextYear = year;
              } else {
                nextDay = parseInt(day) + 1;
                nextMonth = month;
                nextYear = year;
              }
              break;
            case 11:
              month = "Nov";

              if (day === 30) {
                nextDay = 1;
                nextMonth = "Dec";
                nextYear = year;
              } else {
                nextDay = parseInt(day) + 1;
                nextMonth = month;
                nextYear = year;
              }
              break;
            case 12:
              month = "Dec";

              if (day === 31) {
                nextDay = 1;
                nextMonth = "Jan";
                nextYear = year + 1;
              } else {
                nextDay = parseInt(day) + 1;
                nextMonth = month;
                nextYear = year;
              }
              break;
          }

          // Daylight Savings
          if (isDST(new Date())) {
            customBadgeTime = Date.parse(`${day} ${month} ${year} 10:00:00 EDT`);
            customBadgeTimeEnd = Date.parse(`${nextDay} ${nextMonth} ${nextYear} 10:00:00 EDT`);
          } else {
            customBadgeTime = Date.parse(`${day} ${month} ${year} 10:00:00 EST`);
            customBadgeTimeEnd = Date.parse(`${nextDay} ${nextMonth} ${nextYear} 10:00:00 EST`);
          }

          // Check if is active time
          let startTimeRemaining = customBadgeTime - new Date().getTime();
          let endTimeRemaining = customBadgeTimeEnd - new Date().getTime();

          // In active time?
          if (startTimeRemaining < 0 && endTimeRemaining > 0) {
            customBadgeTimeActive = true;
          } else {
            customBadgeTimeActive = false;
          }

          // After active time?
          if (startTimeRemaining < 0) {
            customBadgeTimeStart = true;
          }

          // Show if active, otherwise stay hidden
          if (customBadgeTimeActive) {
            badge.classList.remove("sk-hidden");
          } else if (customBadgeTimeStart && badge.innerText === "STAFF PICK") {
            badge.classList.remove("sk-hidden");
          }
        });
      }
    });

    /* Add observer for wishlist */
    let wishlistLoader = setInterval(() => {
      if (document.querySelector(".swym-modals-container")) {
        clearInterval(wishlistLoader);

        // Add wishlist modal mutation observer
        function swymModalMutationCallback(mutationList, observer) {
          for (const mutation of mutationList) {
            if (mutation.type === "childList") {
              // Add notif listener for when add to wishlist
              let addToListTimeout = undefined;
              let addToListBtnInterval = setInterval(() => {
                if (Array.from(document.querySelectorAll(".swym-add-to-list-btn")).length > 0) {
                  clearInterval(addToListBtnInterval);
                  clearTimeout(addToListTimeout);

                  Array.from(document.querySelectorAll(".swym-add-to-list-btn")).forEach(btn => {
                    btn.addEventListener("click", () => {
                      document.querySelectorAll(".bookmarks-btn__notification").forEach(notif => {
                        notif.classList.add("active");
                      });
                      document.querySelectorAll(".bookmarks-btn__blur").forEach(blurElem => {
                        blurElem.classList.add("active");
                      });

                      // Clear notification after seconds
                      setTimeout(() => {
                        document.querySelectorAll(".bookmarks-btn__notification").forEach(notif => {
                          notif.classList.remove("active");
                        });
                        document.querySelectorAll(".bookmarks-btn__blur").forEach(blurElem => {
                          blurElem.classList.remove("active");
                        });
                      }, 2000);
                    });
                  });
                }
              }, 250);

              addToListTimeout = setTimeout(() => {
                console.warn("Could not find add to list button");
                clearInterval(addToListBtnInterval);
              }, 5000);
            }
          }
        }

        let targetElem = document.querySelector(".swym-modals-container");
        let config = {childList: true};
        let observer = new MutationObserver(swymModalMutationCallback);
        observer.observe(targetElem, config);

        // Init wishlist
        try {
          _swat.initializeActionButtons("#product-list");
        } catch (e) {
          console.warn(e);
        }
      }
    }, 500);
  }

  // Click Listeners
  async function addToCartClick(e) {
    e.preventDefault();

    let productCard = e.currentTarget.parentElement.parentElement;
    let addToCartBtnText = e.currentTarget.querySelector(".add-to-cart-btn__text.add-to-cart-btn__text--add");

    const vid = productCard.dataset.vid;
    let quantity = 1;
    const quantityMax = productCard.dataset.qmax;

    // bogo
    const isBogo = productCard.dataset.bogo === "true" ? true : false;

    // change quantity if bogo
    // if (isBogo) {
    //   let quantityDouble = quantity * 2;
    //   let policyDeny = quantityMax === -1 ? false : true;
    //   let remainingCount = quantityMax;
    //   let cartCount = 0;

    //   // get quantity in cart
    //   document.querySelectorAll("#cart-side .cart-body .line-items-list .line-item").forEach(function (item) {
    //     if (item.getAttribute("data-vid") === vid) {
    //       if (item.getAttribute("data-is-bogo-side") === "false") {
    //         const cartQuantity = parseInt(item.querySelector(".line-item__col.line-item__col--quantity input[type='number'].quantity-value").value);
    //         cartCount += cartQuantity;
    //       } else if (item.getAttribute("data-is-bogo-side") === "true") {
    //         const cartQuantity = parseInt(item.querySelector(".line-item__col.line-item__col--price .line-item__discount-free").innerText.split(" ")[0]);
    //         cartCount += cartQuantity;
    //       }
    //     }
    //   });

    //   if (remainingCount - cartCount < quantityDouble && policyDeny) {
    //     quantity = quantity;
    //   } else {
    //     quantity = quantityDouble;
    //   }
    // }

    // Limit of One Data Check
    if (productCard.dataset.limit === "true") {
      // Get cart data
      const cartData = await Global.Cart.cart();

      if (productCard.dataset.limitV === "true") {
        // Limit of One Variant Check (per variant)
        // Check current quantity in cart
        const variantId = parseInt(productCard.dataset.vid);
        const matchingVariant = cartData.items.find(item => item.variant_id === variantId);

        // If quantity > 1, return error
        if (matchingVariant && matchingVariant.quantity > 1) {
          // Show error
          addToCartBtnText.innerText = "LIMIT REACHED";
          return;
        }
      } else {
        // Limit of One Product Check (per product)
        // Check current quantity
        const productId = parseInt(productCard.dataset.pid);
        const matchingItem = cartData.items.find(item => item.product_id === productId);

        // Exists and exceeds quantity limit?
        if (matchingItem && matchingItem.quantity > 0) {
          // Show error
          addToCartBtnText.innerText = "LIMIT REACHED";
          return;
        }
      }
    }

    // Show loading
    addToCartBtnText.innerText = "ADDING";

    //adds to cart, refreshes the sidecart and shows the sidecart
    Global.Cart.add({id: vid, quantity: quantity})
    .then(res => {
      const quantityInCart = res.items[0].quantity;
      const isDesktop = window.matchMedia("only screen and (min-width: 768px)").matches;

      Global.SideCart.refresh();

      if (isDesktop) {
        // Global.SideCart.show();
      } else {
        // setup data for notification popup
        const comparePriceText = productCard.dataset.notifCprice;
        const priceText = productCard.dataset.notifPrice;
        const url = productCard.dataset.url;
        const imageSrc = productCard.dataset.src;
        const variantTitle = productCard.dataset.vtitle;

        NotificationPopups.show({
          comparePrice: comparePriceText,
          link: url,
          price: priceText,
          quantity: quantity,
          src: imageSrc,
          variantTitle: variantTitle,
          quantityCart: quantityInCart,
          quantityMax: quantityMax,
          variantId: vid,
        });
      }

      // End Loading
      addToCartBtnText.innerText = "ADD TO CART";
    })
    .catch(e => {
      return;
    });
  }

  function seeMoreClick(e) {
    // e.preventDefault();

    // let isDesktop = window.matchMedia("only screen and (min-width: 768px)").matches;
    // let productCard = e.currentTarget.parentElement.parentElement;

    // location.href = productCard.dataset.url;

    // if (isDesktop) {
    //   location.href = productCard.dataset.url;
    // } else {
    //   ProductView.Show(productCard.dataset.url);
    // }
  }

  let notifyMeTimeout = undefined;
  function notifyClick(e = undefined) {
    if (e) e.preventDefault();

    if (notifyMeTimeout) clearTimeout(notifyMeTimeout);

    try {
      let pCard = e.currentTarget.parentElement.parentElement;
      let pUrl = `${document.body.getAttribute("data-url")}${pCard.getAttribute("data-url")}`;
      let pid = pCard.getAttribute("data-pid");
      let vid = pCard.getAttribute("data-vid");

      let params = {
        empi: pid,
        epi: vid,
        du: pUrl,
      };

      // Shows notify me
      _swat.getProductDetails(params, function(productJSON) {
        productJSON.variants.forEach(function(v) {
          if (v.id == vid) {
            params.pr = SwymUtils.formatProductPrice(v.price);
            params.iu = productJSON.featured_image;
            params.et = 8;
            _swat.addToWatchList(e, params, function(e) {
              console.log("Subscribed to product!", e);
            }); // Shows Subscribe me.
            return;
          }

        });
      });
    } catch (err) {
      notifyMeTimeout = setTimeout(() => {
        notifyClick(e);
      }, 500);
    }
  }

  initEvents();

  return Object.freeze({
    initEvents,
  });
})();

/* ===== Pagination Namespace ===== */
const Pagination = (() => {
  /* ===== Local ===== */
  // Note: Page number starts at 1, not 0
  // - Elems
  let paginationDataElem = document.getElementById("pagination-data");

  // - Url
  let baseUrl = document.body.getAttribute("data-url");
  let collectionUrl = paginationDataElem.getAttribute("data-collection-url");
  let sortBy = paginationDataElem.getAttribute("data-sort-by");

  // - Regular global
  let productCount = parseInt(paginationDataElem.getAttribute("data-product-count"));
  let productCountPerPage = parseInt(paginationDataElem.getAttribute("data-products-per-page"));

  // - Regular page
  let currPageNum = parseInt(paginationDataElem.getAttribute("data-current-page"));
  let pageCount = parseInt(paginationDataElem.getAttribute("data-page-count"));

  // - Filtered page
  let filteredCurrPageNum = 0;
  let filteredPageCount = 0;
  let filteredProductCount = 0;

  /* ===== Url ===== */
  /**
   * - Returns absolute url of current page
   * - Takes optional input for desired page number
   */
  function GetUrl(pageNum = -1) {
    if (pageNum < 0) {
      pageNum = currPageNum;
    }

    return `${baseUrl}${collectionUrl}?page=${pageNum}&sort_by=${sortBy}`;
  }

  /**
   * - Returns relative url of current page
   * - Takes optional input for desired page number
   */
  function GetRelativeUrl(pageNum = -1) {
    if (pageNum < 0) {
      pageNum = currPageNum;
    }

    return `${collectionUrl}?page=${pageNum}&sort_by=${sortBy}`;
  }

  /* ===== Page ===== */
  function GetCurrPageNum() {
    return currPageNum;
  }

  function GetPageCount() {
    return pageCount;
  }

  function GetProductCount() {
    return productCount;
  }

  function GetProductCountPerPage() {
    return productCountPerPage;
  }

  function SetCurrPageNum(pageNum = 1) {
    currPageNum = pageNum;
    paginationDataElem.setAttribute("current-page-num", currPageNum);

    // Update url
    history.replaceState(null, "", GetUrl());

    document.title = `${document.title.split("–")[0]} – Page ${pageNum} – SUKOSHI MART`;
  }

  /* ===== Filtered Page ===== */
  function GetFilteredCurrPageNum() {
    return filteredCurrPageNum;
  }

  function GetFilteredPageCount() {
    return filteredPageCount;
  }

  function GetFilteredProductCount() {
    return filteredProductCount;
  }

  function SetFilteredCurrPageNum(pageNum = 1) {
    filteredCurrPageNum = pageNum;
  }

  function SetFilteredPageCount(pageCount = 1) {
    filteredPageCount = pageCount;
  }

  function SetFilteredProductCount(productCount = 0) {
    filteredProductCount = productCount;
  }

  function GetSortBy() {
    return sortBy;
  }

  function GetCollectionUrl() {
    return collectionUrl;
  }

  /* ===== Freeze ===== */
  return Object.freeze({
    GetUrl,
    GetRelativeUrl,
    GetCurrPageNum,
    GetPageCount,
    GetProductCount,
    GetProductCountPerPage,
    SetCurrPageNum,
    GetFilteredCurrPageNum,
    GetFilteredPageCount,
    GetFilteredProductCount,
    SetFilteredCurrPageNum,
    SetFilteredPageCount,
    SetFilteredProductCount,
    GetSortBy,
    GetCollectionUrl,
  });
})();

/* ===== Pages Namespace ===== */
const Pages = (() => {
  /* ===== Local ===== */
  // Note: Page indexing starts at 1, not 0
  const DEBUG = true;

  let pages = [];
  let filteredPages = [[], []];
  let filteredPageCount = 1;
  let filteredProductCount = 0;

  let isFiltered = false;
  let downloadedAllPages = false;

  let filteredPageDur = 500;

  let customFilters = document.getElementById("custom-filter-list").getAttribute("data-filters").split(",");

  /* Setup custom filters */
  if (customFilters.length > 0) {
    customFilters = customFilters.map(filter => filter.trim().split("[")[0].toLowerCase());
  }

  /* ===== Page Functions ===== */
  /**
   * - Returns an array of products for the page number provided
   * - If products are not already downloaded, it downloads it and then returns the array
   * - On error, returns undefined
   */
  async function GetPage(pageNum = 0) {
    if (!IsValidPage(pageNum)) {
      if (DEBUG) {
        console.warn("Invalid page requested");
      }

      return undefined;
    }

    // let targetPage = await DownloadPage(pageNum).then(res => res);

    // return targetPage;

    if (IsEmptyPage(pageNum)) {
      // if (DEBUG) {
      //   console.log("Empty page requested");
      // }

      // Download page
      let targetPage = await DownloadPage(pageNum).then(res => res);

      return targetPage;
    } else {
      // if (DEBUG) {
      //   console.log("Downloaded page requested");
      // }

      return pages[pageNum];
    }
  }

  /**
   * - If filters not applied yet, apply filters
   * - On success, return filtered page array
   * - On error, return undefined
   */
  async function GetFilteredPage(pageNum = 0) {
    return new Promise((resolve, reject) => {
      // Filter if isn't already filtered
      if (!isFiltered) {
        FilterProducts();
      }

      if (!IsValidFilteredPage(pageNum)) {
        if (DEBUG) {
          console.warn("Requested invalid filtered page");
        }

        setTimeout(() => {
          resolve(undefined);
        }, filteredPageDur);
      }

      setTimeout(() => {
        resolve(filteredPages[pageNum]);
      }, filteredPageDur);
    });
  }

  /* ===== Filter Functions ===== */
  function FilterProducts() {
    // go through pages and only retrieve products matching filters
    let filters = activeFilters;
    let foundProducts = [];

    // if (DEBUG) {
    //   console.log("Filtering..");
    // }

    if (filters.length <= 0) {
      if (DEBUG) {
        console.warn("No filters found for filtering");
      }

      isFiltered = false;

      return;
    }

    // Get all matching filtered products
    for (let i = 1; i <= pages.length; i++) {
      if (pages[i]) {
        foundProducts = foundProducts.concat(pages[i].filter(product => {
          return (filters.some(filter => {
            let matchingRightTag = product.dataset.rightTag && product.dataset.rightTag.split(",").find(tag => tag == filter);
            let matchingBundle = product.dataset.bundleTag && product.dataset.bundleTag.split(",").find(tag => tag == filter);
            let matchingCustom = false;

            if (customFilters.length > 0) {
              matchingCustom = customFilters.some(cFilter => product.hasAttribute(`data-${cFilter}-tag`) && product.getAttribute(`data-${cFilter}-tag`).split(",").find(tag => tag == filter));
            }

            return (matchingRightTag || matchingBundle || matchingCustom);
          }) ||
          filters.some(filter => {
            let matchingBrand = product.dataset.brandTag && product.dataset.brandTag.split(",").find(tag => tag == filter);
            return matchingBrand;
          }));
        }));
      }
    }

    // Init filtered
    filteredPages = [[], []];
    filteredPageCount = 1;
    filteredProductCount = 0;

    let productCount = 0;

    // Create pages out of filtered products found
    foundProducts.forEach(product => {
      if (productCount === Pagination.GetProductCountPerPage()) {
        productCount = 0;
        filteredPageCount += 1;

        filteredPages[filteredPageCount] = [];
      }

      filteredPages[filteredPageCount].push(product);

      productCount++;
      filteredProductCount++;
    });

    // Update pagination
    Pagination.SetFilteredPageCount(filteredPageCount);
    Pagination.SetFilteredProductCount(filteredProductCount);
    Pagination.SetFilteredCurrPageNum(1);

    // Reset highest page loaded for filter
    CollectionPage.SetVisiblePageCount(0);
    CollectionPage.SetHighestFilteredPageLoadedNum(1);
    CollectionPage.SetHighestPageLoadedNum(1);

    isFiltered = true;
  }

  async function AddFilterCallback() {
    // Remove all products
    CollectionPage.RemoveAllProducts();
    PageStateUtil.StartLoading("top");

    if (downloadedAllPages) {
      // Create filtered product list based on current filters
      FilterProducts();

      // Add filtered page 1
      CollectionPage.AddFilteredPageToBottom(1);
      PageStateUtil.StopLoadingAtPage(1);
    } else {
      // Download all pages
      let result = await DownloadAllPages()
      .then(pages => {
        downloadedAllPages = true;

        // Create filtered product list based on current filters
        FilterProducts();

        // Add filtered page 1
        CollectionPage.AddFilteredPageToBottom(1);
        PageStateUtil.StopLoadingAtPage(1);
      })
      .catch(res => {
        if (DEBUG) {
          console.warn(res);
        }
      });
    }
  }

  async function RemoveFilterCallback() {
    // Remove all products
    CollectionPage.RemoveAllProducts();
    PageStateUtil.StartLoading("top");

    if (activeFilters.length === 0) {
      // Clear filters
      isFiltered = false;
      filteredPages = [[], []];
      filteredPageCount = 1;
      filteredProductCount = 0;

      // Update pagination
      Pagination.SetFilteredCurrPageNum(1);
      Pagination.SetFilteredPageCount(0);

      // Update tracker
      CollectionPage.SetVisiblePageCount(0);
      CollectionPage.SetHighestFilteredPageLoadedNum(1);
      CollectionPage.SetHighestPageLoadedNum(1);

      // Show collection page 1
      CollectionPage.AddPageToBottom(1);
      PageStateUtil.StopLoadingAtPage(1);

      // Update title
      let titleContainer = document.querySelector('.main-collection-title');
      titleContainer.style.paddingBottom = "10px";

      // Update filters
      document.querySelectorAll('.filter-container')[1].innerHTML = "No filters selected";
      document.querySelector('.mobile-all-filter-modal').classList.remove('has-filters');
    } else {
      if (downloadedAllPages) {
        // Create filtered product list based on current filters
        FilterProducts();

        // Add filtered page 1
        CollectionPage.AddFilteredPageToBottom(1);
        PageStateUtil.StopLoadingAtPage(1);
      } else {
        // Download all pages
        let result = await DownloadAllPages()
        .then(pages => {
          downloadedAllPages = true;

          // Create filtered product list based on current filters
          FilterProducts();

          // Add filtered page 1
          CollectionPage.AddFilteredPageToBottom(1);
          PageStateUtil.StopLoadingAtPage(1);
        })
        .catch(res => {
          if (DEBUG) {
            console.warn(res);
          }
        });
      }
    }
  }

  /* ===== Helper Functions ===== */
  // Regular Bools
  /**
   * - Checks if page exists at page number
   */
  function IsEmptyPage(pageNum = 0) {
    return (pages[pageNum] === undefined);
  }

  /**
   * - Checks page number to be between 1 and page count
   */
  function IsValidPage(pageNum = 0) {
    return (
      pageNum > 0 &&
      pageNum <= Pagination.GetPageCount()
    );
  }

  // Filtered Bools
  /**
   * - Checks if is currently filtered
   */
  function IsFiltered() {
    return isFiltered;
  }

  /**
   * - Checks page number to be between 1 and page count
   */
  function IsValidFilteredPage(pageNum = 0) {
    return (
      pageNum > 0 &&
      pageNum <= Pagination.GetFilteredPageCount()
    );
  }

  // Download
  /**
   * - Downloads page and saves the products found in the page array
   * - On success, returns promise containing saved products array
   * - On error, returns undefined
   */
  async function DownloadPage(pageNum = 1) {
    return new Promise(async (resolve, reject) => {
      // if (DEBUG) {
      //   console.log(`Downloading page ${pageNum}..`);
      // }

      let result = await fetch(Pagination.GetUrl(pageNum))
      .then(res => res.text())
      .then(res => {
        // Recreate page as an html element
        let pageContent = document.createElement('div');
        pageContent.innerHTML = res;

        // Save page's products as an array
        pages[pageNum] = Array.from(pageContent.querySelectorAll('.product-card'));

        // if (DEBUG) {
        //   console.log(`Done page ${pageNum}`);
        // }

        resolve(pages[pageNum]);
        // resolve(Array.from(pageContent.querySelectorAll('.product-card')));
      })
      .catch(res => {
        resolve(undefined);
      });
    });
  }

  /**
   * - Downloads all pages and saves into the page array -- runs on filter
   * - Returns promise with all downloaded pages
   */
  async function DownloadAllPages() {
    if (DEBUG) {
      console.log(`Downloading all pages..`);
    }

    return new Promise((resolve, reject) => {
      let allPages = [[]];
      let pageNum = 0;
      let pageCount = Pagination.GetPageCount();

      for (let i = 1; i <= pageCount; i++) {
        pageNum = i;
        allPages.push(DownloadPage(pageNum));
      }

      Promise.all(allPages).then(resPages => {
        if (DEBUG) {
          console.log(`Done downloading all pages`);
        }

        pages = resPages;

        downloadedAllPages = true;

        resolve(resPages);
        return;
      });
    });
  }

  /* ===== Freeze ===== */
  return Object.freeze({
    AddFilterCallback,
    GetFilteredPage,
    GetPage,
    IsFiltered,
    RemoveFilterCallback,
  });
})();

/* ===== Page State Util ===== */
const PageStateUtil = (() => {
  let lowest = 1;
  let highest = 1;
  let max = 15;

  /**
   * Get/Set
   */
  function GetLowest() {
    return lowest;
  }

  function SetLowest(pageNum = undefined) {
    if (pageNum === undefined) return;
    lowest = pageNum;
  }

  function GetHighest() {
    return highest;
  }

  function SetHighest(pageNum = undefined) {
    if (pageNum === undefined) return;
    highest = pageNum;
  }

  function ResetLowestHighest() {
    highest = lowest = 1;
  }

  /**
   * Bound Checks
   */
  function IsUnderPageOne(pageNum = undefined) {
    if (pageNum === undefined) return false;

    if (pageNum < 1) {
      return true;
    }

    return false;
  }

  function IsOverPageCount(pageNum = undefined) {
    if (pageNum === undefined) return false;
    let pageCount = Pages.IsFiltered() ? Pagination.GetFilteredPageCount() : Pagination.GetPageCount();

    if (pageNum > pageCount) {
      return true;
    }

    return false;
  }

  function IsOverMaxPage() {
    if (highest - lowest < max) {
      return false;
    }

    return true;
  }

  /**
   * Loading
   */
  function StartLoading(position = "top") {
    // Hide load buttons
    LoadBtnUtil.HideLoadPrevBtn();
    LoadBtnUtil.HideLoadNextBtn();

    position = position.toLowerCase();

    if (position === "bottom") {
      Loading.ShowBottom();
    } else {
      Loading.ShowTop();
    }
  }

  function StopLoadingAtPage(pageNum = undefined) {
    // Hide Load Buttons
    LoadBtnUtil.HideLoadPrevBtn();
    LoadBtnUtil.HideLoadNextBtn();

    // Show load more if next page exists
    if (pageNum) {
      LoadBtnUtil.RefreshLoadPrevBtn(pageNum);
      LoadBtnUtil.RefreshLoadNextBtn(pageNum);
    } else {
      LoadBtnUtil.RefreshLoadPrevBtn(PageStateUtil.GetLowest());
      LoadBtnUtil.RefreshLoadNextBtn(PageStateUtil.GetHighest());
    }

    // Hide Load
    Loading.HideTop();
    Loading.HideBottom();
  }

  /**
   * Validate
   */
  function ValidateLowestPage() {
    while (IsOverMaxPage()) {
      SetLowest(GetLowest() + 1);
      CollectionPage.RemovePageFromTop();
    }
  }

  function ValidateHighestPage() {
    while (IsOverMaxPage()) {
      SetHighest(GetHighest() - 1);
      CollectionPage.RemovePageFromBottom();
    }
  }

  return Object.freeze({
    // Get/Set
    GetLowest,
    SetLowest,
    GetHighest,
    SetHighest,
    ResetLowestHighest,
    // Bound Checks
    IsUnderPageOne,
    IsOverPageCount,
    IsOverMaxPage,
    // Loading
    StartLoading,
    StopLoadingAtPage,
    // Validate
    ValidateLowestPage,
    ValidateHighestPage,
  });
})();

/* ===== Load Button Util ===== */
const LoadBtnUtil = (() => {
  let loadPrevBtn = document.querySelector(".load-more-btn--prev");
  let loadNextBtn = document.querySelector(".load-more-btn--next");

  /**
   * Hide/Show
   */
  function HideLoadPrevBtn() {
    loadPrevBtn.classList.add("sk-hidden");
  }

  function HideLoadNextBtn() {
    loadNextBtn.classList.add("sk-hidden");
  }

  function ShowLoadPrevBtn() {
    loadPrevBtn.classList.remove("sk-hidden");
  }

  function ShowLoadNextBtn() {
    loadNextBtn.classList.remove("sk-hidden");
  }

  /**
   * Get/Set
   */
  function SetLoadPrevBtnUrl(prevPageNum = undefined) {
    if (prevPageNum === undefined) return;

    loadPrevBtn.setAttribute("href", `${Pagination.GetRelativeUrl(prevPageNum)}`);
  }

  function SetLoadNextBtnUrl(nextPageNum = undefined) {
    if (nextPageNum === undefined) return;

    loadNextBtn.setAttribute("href", `${Pagination.GetRelativeUrl(nextPageNum)}`);
  }

  /**
   * Refresh State Handlers
   */
  function RefreshLoadPrevBtn(currPageNum = undefined) {
    if (currPageNum === undefined) return;

    let prevPageNum = currPageNum - 1;

    if (prevPageNum > 0) {
      ShowLoadPrevBtn();
      SetLoadPrevBtnUrl(prevPageNum);
    } else {
      HideLoadPrevBtn();
    }
  }

  function RefreshLoadNextBtn(currPageNum = undefined) {
    if (currPageNum === undefined) return;

    let nextPageNum = currPageNum + 1;

    if (!PageStateUtil.IsOverPageCount(nextPageNum)) {
      ShowLoadNextBtn();
      SetLoadNextBtnUrl(nextPageNum);
    } else {
      HideLoadNextBtn();
    }
  }

  /**
   * Click Handlers
   */
  function ClickLoadPrevBtn(e) {
    e.preventDefault();

    PageStateUtil.StartLoading("top");

    // Update Page Number
    let currPageNum = Pages.IsFiltered() ? Pagination.GetFilteredCurrPageNum() : Pagination.GetCurrPageNum();
    let targetPageNum = currPageNum - 1;

    if (currPageNum > PageStateUtil.GetLowest()) {
      targetPageNum = PageStateUtil.GetLowest() - 1;
    }

    if (PageStateUtil.IsUnderPageOne(targetPageNum)) {
      console.warn("At first page - halt loading");
      PageStateUtil.StopLoadingAtPage(1);
      return;
    }

    // Set New Page State
    PageStateUtil.SetLowest(targetPageNum);
    PageStateUtil.ValidateHighestPage();

    if (Pages.IsFiltered()) {
      console.log(`${Pagination.GetFilteredCurrPageNum()} -> ${targetPageNum} (${PageStateUtil.GetLowest()}, ${PageStateUtil.GetHighest()} | ${PageStateUtil.GetHighest() - PageStateUtil.GetLowest()})`);

      CollectionPage.AddFilteredPageToTop(targetPageNum, true)
      .then(res => {
        // End loading
        PageStateUtil.StopLoadingAtPage();
      });
    } else {
      console.log(`${Pagination.GetCurrPageNum()} -> ${targetPageNum} (${PageStateUtil.GetLowest()}, ${PageStateUtil.GetHighest()} | ${PageStateUtil.GetHighest() - PageStateUtil.GetLowest()})`);

      CollectionPage.AddPageToTop(targetPageNum, true)
      .then(res => {
        // End loading
        PageStateUtil.StopLoadingAtPage();
      });
    }
  }

  function ClickLoadMoreBtn(e) {
    e.preventDefault();

    PageStateUtil.StartLoading("bottom");

    // Update Page Number
    let currPageNum = Pages.IsFiltered() ? Pagination.GetFilteredCurrPageNum() : Pagination.GetCurrPageNum();
    let targetPageNum = currPageNum + 1;

    if (currPageNum < PageStateUtil.GetHighest()) {
      targetPageNum = PageStateUtil.GetHighest() + 1;
    }

    if (PageStateUtil.IsOverPageCount(targetPageNum)) {
      console.warn("At last page - halt loading");
      PageStateUtil.StopLoadingAtPage(currPageNum);

      return;
    }

    // Set New Page State
    PageStateUtil.SetHighest(targetPageNum);
    PageStateUtil.ValidateLowestPage();

    if (Pages.IsFiltered()) {
      console.log(`${Pagination.GetFilteredCurrPageNum()} -> ${targetPageNum} (${PageStateUtil.GetLowest()}, ${PageStateUtil.GetHighest()} | ${PageStateUtil.GetHighest() - PageStateUtil.GetLowest()})`);

      CollectionPage.AddFilteredPageToBottom(targetPageNum, true)
      .then(res => {
        // End loading
        PageStateUtil.StopLoadingAtPage();
      });
    } else {
      console.log(`${Pagination.GetCurrPageNum()} -> ${targetPageNum} (${PageStateUtil.GetLowest()}, ${PageStateUtil.GetHighest()} | ${PageStateUtil.GetHighest() - PageStateUtil.GetLowest()})`);

      CollectionPage.AddPageToBottom(targetPageNum, true)
      .then(res => {
        // End loading
        PageStateUtil.StopLoadingAtPage();
      });
    }
  }

  return Object.freeze({
    // Hide/Show
    HideLoadPrevBtn,
    HideLoadNextBtn,
    ShowLoadPrevBtn,
    ShowLoadNextBtn,
    // Get/Set
    SetLoadPrevBtnUrl,
    SetLoadNextBtnUrl,
    // Refresh State Handlers
    RefreshLoadPrevBtn,
    RefreshLoadNextBtn,
    // Click Handlers
    ClickLoadPrevBtn,
    ClickLoadMoreBtn,
  });
})();

/* ===== Collection Page Namespace ===== */
const CollectionPage = (() => {
  /* ===== Local ===== */
  const DEBUG = true;

  // - Load
  let loadMoreBtnPrev = document.querySelector(".load-more-btn--prev");
  let loadMoreBtnNext = document.querySelector(".load-more-btn--next");
  let loadMoreInit = false;

  // - Timers
  let scrollUpdateTimeout = undefined;
  let scrollUpdateDur = 1000;
  let scrollBackDur = 100;

  let pageLoadTimeout = undefined;
  let pageLoadDur = 500;

  let loadNextPageDur = 1000;

  // - Page Tracker (for scroll)
  let visiblePageCount = 1;
  let highestPageLoadedNum = 1;
  let highestFilteredPageLoadedNum = 1;

  let addedToTop = false;
  let addedToBottom = false;

  let pageArray = [];
  let filteredPageArray = [];

  // - Collection
  let productContainer = document.querySelector(".product-grid");
  let productCountElem = document.querySelector(".main-collection-title h1 sub");

  // - PLF related elems
  const plfProductContainer = document.querySelector(".collection__plf-product-grid");
  const plfProductCountElem = document.querySelector(".collection__plf-title h1 sub");

  if (plfProductContainer) {
    productContainer = plfProductContainer;
  }

  if (plfProductCountElem) {
    productCountElem = plfProductCountElem;
  }

  /* ===== Init Functions ===== */
  /**
   * - Runs on start
   */
  function OnStart() {
    // Events
    // document.addEventListener("scroll", OnScroll);

    // Init
    pageArray.push(Pagination.GetCurrPageNum());

    PageStateUtil.SetLowest(Pagination.GetCurrPageNum());
    PageStateUtil.SetHighest(Pagination.GetCurrPageNum());
    LoadMoreInit();

    // Tracker
    highestPageLoadedNum = Pagination.GetCurrPageNum();
    highestFilteredPageLoadedNum = 1;
    visiblePageCount = 1;

    // Check if filters already
    // Get session storage data
    let sessionFilterList = sessionStorage.getItem("currFilters");
    const sessionCurrUrl = sessionStorage.getItem("currUrl");

    // Get url to see if bundle exists
    const url = window.location.href;

    if (url.includes("#")) {
      let hash = url.split("#")[1];

      if (hash !== "" && hash.includes("bundle")) {
        let hashSplit = hash.split("-");

        for (let i = 0; i < hashSplit.length; i++) {
          hashSplit[i] = hashSplit[i].charAt(0).toUpperCase() + hashSplit[i].slice(1);
        }

        let bundleName = hashSplit.join(" ");

        if (sessionFilterList === null || sessionFilterList === "") {
          sessionFilterList = bundleName;
        } else {
          if (!sessionFilterList.includes(bundleName)) {
            sessionFilterList.concat(",", bundleName);
          }
        }
      } else if (hash !== "") {
        // Check if hash exists as a filter before adding it
        let collTags = document.querySelector("[data-coll-tags]").getAttribute("data-coll-tags").split(",");

        if (collTags.find(tag => tag.split(":")[1] === hash) === false) {
          return;
        }

        let hashSplit = hash.split("-");

        for (let i = 0; i < hashSplit.length; i++) {
          hashSplit[i] = hashSplit[i].charAt(0).toUpperCase() + hashSplit[i].slice(1);
        }

        let filterName = hashSplit.join(" ");

        if (sessionFilterList === null || sessionFilterList === "") {
          sessionFilterList = filterName;
        } else {
          if (!sessionFilterList.includes(filterName)) {
            sessionFilterList.concat(",", filterName);
          }
        }
      }
    }

    // No filters found ?
    if (sessionFilterList === null || sessionFilterList === "" ||
        sessionCurrUrl === null || sessionCurrUrl === "") {

      // If not on first page, load prev 2 pages if possible
      if (Pagination.GetCurrPageNum() > 1) {
        return;

        AddPageToTop(Pagination.GetCurrPageNum() - 1, false, () => {
          AddPageToTop(Pagination.GetCurrPageNum() - 1, false, () => {
            // Scroll to top of current page
            Pagination.SetCurrPageNum(Pagination.GetCurrPageNum() + 2);

            setTimeout(() => {
              scrollTo(0, Array.from(document.querySelectorAll(".product-card"))[(Pagination.GetProductCountPerPage() * 2)].offsetTop - 110);
            }, 1000);
          });
        });
      }
    }
  }

  /**
   * - Initializes load more
   */
  function LoadMoreInit() {
    if (loadMoreBtnPrev === null || loadMoreBtnNext === null) {
      console.warn("Could not find load more btn");
      return;
    }

    if (Pages.IsFiltered()) {
      LoadBtnUtil.RefreshLoadPrevBtn(PageStateUtil.GetLowest());
      LoadBtnUtil.RefreshLoadNextBtn(PageStateUtil.GetHighest());
    } else {
      LoadBtnUtil.RefreshLoadPrevBtn(PageStateUtil.GetLowest());
      LoadBtnUtil.RefreshLoadNextBtn(PageStateUtil.GetHighest());
    }

    // Init
    if (loadMoreInit === false) {
      loadMoreBtnPrev.addEventListener("click", LoadBtnUtil.ClickLoadPrevBtn);
      loadMoreBtnNext.addEventListener("click", LoadBtnUtil.ClickLoadMoreBtn);
      loadMoreInit = true;
    }
  }

  function ProductEventInit() {
    initCollectionProducts();
    ProductCards.initEvents();
  }

  /* ===== Events ===== */
  /**
   * - Runs on scroll
   */
  function OnScroll() {
    // set updates on timeout to avoid updating every frame
    if (scrollUpdateTimeout === undefined) {
      scrollUpdateTimeout = setTimeout(() => {
        // clear timeout
        scrollUpdateTimeout = undefined;

        if (DEBUG) {
          console.log(pageArray.length, highestPageLoadedNum, highestFilteredPageLoadedNum);
        }

        // run updates
        AddPageBasedOnScrollPos();
        RemovePageIfOverLimit();
      }, scrollUpdateDur);
    }
  }

  /* ===== Scroll Updates ===== */
  /**
   * - Check if within bounds to load a new page
   */
  function AddPageBasedOnScrollPos() {
    let userScroll = scrollY;
    let screenHeight = productContainer.clientHeight;

    // slice screen height into 5 pieces
    // idea: based on where the scroll position is within these 5 different pieces, load/unload content
    //   1-2: remove from bottom and add to top
    //   3: nothing
    //   4-5: remove from top and add to bottom
    //   note: 4-5 doesn't happen unless we want auto load to happens
    let partitionCount = 5;

    // if (window.matchMedia("(min-width: 1024px)").matches) {
      // Desktop
      // partitionCount = 5;
    // } else if (window.matchMedia("(min-width: 768px)").matches) {
      // Tablet
      // partitionCount = 7;
    // }

    let screenPartitionHeight = screenHeight / partitionCount;

    // determine where currencty scroll position lies within the divided sections of the screen height, then take action based on the index found
    let userScrollPartition = Math.floor(userScroll / screenPartitionHeight) + 1; // + 1 to index by 1 instead of 0

    if (Loading.IsLoading()) {
      if (DEBUG) {
        console.warn("Is already loading a page!");
      }

      // Set timeout to check again to load another page
      if (pageLoadTimeout !== undefined) {
        clearTimeout(pageLoadTimeout);
      }

      pageLoadTimeout = setTimeout(() => {
        if (DEBUG) {
          console.log(pageArray.length, highestPageLoadedNum, highestFilteredPageLoadedNum);
        }

        // run updates
        AddPageBasedOnScrollPos();
        RemovePageIfOverLimit();
      }, pageLoadDur);

      return;
    } else {
      if (DEBUG) {
        console.log(`partition: ${userScrollPartition} [${pageArray}] [${filteredPageArray}], P: ${pageArray[0] - 1} : ${Pagination.GetCurrPageNum()} : ${pageArray[pageArray.length - 1] + 1}; FP: ${filteredPageArray[0] - 1} : ${Pagination.GetFilteredCurrPageNum()} : ${filteredPageArray[filteredPageArray.length - 1] + 1}`, Array.from(document.querySelectorAll(".product-card")).length);
      }
    }

    if (userScrollPartition <= 1) {
      // within partition 1-2

      if (Pages.IsFiltered()) {
        // Get prev page
        let pagePrev = filteredPageArray[0] - 1;

        // If none, return
        if (pagePrev < 1) {
          if (DEBUG) {
            console.warn("At first page");
          }

          return;
        }

        if (filteredPageArray[0] > 1) {
          if (pageLoadTimeout !== undefined) {
            clearTimeout(pageLoadTimeout);
          }

          // Loading.ShowTop();
          pageLoadTimeout = setTimeout(() => {
            if (DEBUG) {
              console.log(filteredPageArray.length, highestPageLoadedNum, highestFilteredPageLoadedNum);
            }

            // run updates
            AddFilteredPageToTop(pagePrev, true);
          }, loadNextPageDur);
        }

        if (DEBUG) {
          console.log(`Loading page ${pagePrev}`);
        }
      } else {
        // Get prev page
        let pagePrev = pageArray[0] - 1;

        // If none, return
        if (pagePrev < 1) {
          if (DEBUG) {
            console.warn("At first page");
          }

          return;
        }

        if (pageArray[0] > 1) {
          if (pageLoadTimeout !== undefined) {
            clearTimeout(pageLoadTimeout);
          }

          // Loading.ShowTop();
          pageLoadTimeout = setTimeout(() => {
            if (DEBUG) {
              console.log(pageArray.length, highestPageLoadedNum, highestFilteredPageLoadedNum);
            }

            AddPageToTop(pagePrev, true);

            // run updates
            // AddPageBasedOnScrollPos();
            // RemovePageIfOverLimit();
          }, loadNextPageDur);
        }

        if (DEBUG) {
          console.log(`Loading page ${pagePrev}`);
        }
      }
    } else if (userScrollPartition >= partitionCount) {
      // within partition 4-5 -- do nothing unless auto load is enabled or before max page
      if (Pages.IsFiltered()) {
        // Get next page
        let pageNext = filteredPageArray[filteredPageArray.length - 1] + 1;

        // If none, return
        if (pageNext > Pagination.GetFilteredPageCount()) {
          if (DEBUG) {
            console.warn("At last page");
          }

          return;
        }

        if (pageNext <= highestFilteredPageLoadedNum) {
          if (pageLoadTimeout !== undefined) {
            clearTimeout(pageLoadTimeout);
          }

          // Loading.ShowBottom();
          pageLoadTimeout = setTimeout(() => {
            // run updates
            AddFilteredPageToBottom(pageNext);
          }, loadNextPageDur);

          if (DEBUG) {
            console.log(`Loading page ${pageNext}`);
          }
        }
      } else {
        // Get next page
        let pageNext = pageArray[pageArray.length - 1] + 1;

        // If none, return
        if (pageNext > Pagination.GetPageCount()) {
          if (DEBUG) {
            console.warn("At last page");
          }

          return;
        }

        if (pageNext <= highestPageLoadedNum) {
          if (pageLoadTimeout !== undefined) {
            clearTimeout(pageLoadTimeout);
          }

          // Loading.ShowBottom();
          pageLoadTimeout = setTimeout(() => {
            // run updates
            AddPageToBottom(pageNext);
          }, loadNextPageDur);

          if (DEBUG) {
            console.log(`Loading page ${pageNext}`);
          }
        }
      }
    }
  }

  /**
   * - Removes page to get back to limit
   * - Returns true if over limit
   */
  function RemovePageIfOverLimit() {
    let visiblePageLimit = 4;

    if (visiblePageCount > visiblePageLimit) {
      if (addedToTop) {
        RemovePageFromBottom();
      }

      if (addedToBottom) {
        RemovePageFromTop();
      }

      return true;
    }

    return false;
  }

  /* ===== Load More ===== */
  /**
   * - Click callback
   */
  function LoadMoreCallback(e) {
    e.preventDefault();

    if (Pages.IsFiltered()) {
      // Get next page
      let pageNext = pageNumData.highest + 1;

      // If none, return
      if (pageNext > Pagination.GetFilteredPageCount()) {
        if (DEBUG) {
          console.warn("At last page, no load more");
        }

        return;
      }

      // Remove Products
      // RemoveAllProducts();

      // Hide collection
      loadMoreBtnPrev.classList.add("sk-hidden");
      loadMoreBtnNext.classList.add("sk-hidden");

      // loadMoreBtnPrev.setAttribute("href", `${Pagination.GetRelativeUrl(1)}`);
      // loadMoreBtnNext.setAttribute("href", `${Pagination.GetRelativeUrl(2)}`);

      // Load
      Loading.ShowBottom();

      // Scroll to top
      // scrollTo({
      //   top: 0,
      //   left: 0,
      //   behavior: "auto",
      // });

      setTimeout(() => {
        // Add Page
        AddFilteredPageToBottom(pageNext, true);

        // Update page tracker
        if (pageNext > highestFilteredPageLoadedNum) {
          highestFilteredPageLoadedNum = pageNext;
        }

        RemoveProductsOnNextPageLoad(pageNext);

        // Set page number to href
        // Prev
        // if (pageNext - 1 > 1) {
        //   loadMoreBtnPrev.setAttribute("href", `${Pagination.GetRelativeUrl(pageNext - 1)}`);
        // } else {
        //   loadMoreBtnPrev.setAttribute("href", `${Pagination.GetRelativeUrl(1)}`);
        // }

        // Next
        let pageCount = Pagination.GetPageCount();

        if (Pages.IsFiltered()) {
          pageCount = Pagination.GetFilteredPageCount();
        }

        if (pageNext + 1 < pageCount) {
          loadMoreBtnNext.setAttribute("href", `${Pagination.GetRelativeUrl(pageNext + 1)}`);
        } else {
          loadMoreBtnNext.setAttribute("href", `${Pagination.GetRelativeUrl(pageCount)}`);
          loadMoreBtnNext.classList.add("sk-hidden");
        }

        if (DEBUG) {
          console.log(`Finished loading page ${pageNext} / ${Pagination.GetFilteredPageCount()}`);
        }
      }, 100);
    } else {
      // Get next page
      let pageNext = pageNumData.highest + 1;

      // If none, return
      if (pageNext > Pagination.GetPageCount()) {
        if (DEBUG) {
          console.warn("At last page, no load more");
        }

        return;
      }

      // Remove Products
      // RemoveAllProducts();

      // Hide collection
      loadMoreBtnPrev.classList.add("sk-hidden");
      loadMoreBtnNext.classList.add("sk-hidden");

      // loadMoreBtnPrev.setAttribute("href", `${Pagination.GetRelativeUrl(1)}`);
      // loadMoreBtnNext.setAttribute("href", `${Pagination.GetRelativeUrl(2)}`);

      // Load
      Loading.ShowBottom();

      // Scroll to top
      // scrollTo({
      //   top: 0,
      //   left: 0,
      //   behavior: "auto",
      // });

      setTimeout(() => {
        // Add Page
        AddPageToBottom(pageNext, true);

        // Update page tracker
        if (pageNext > highestPageLoadedNum) {
          highestPageLoadedNum = pageNext;
        }

        RemoveProductsOnNextPageLoad(pageNext);

        // Set page number to href
        // Prev
        // if (pageNext - 1 > 1) {
        //   loadMoreBtnPrev.setAttribute("href", `${Pagination.GetRelativeUrl(pageNext - 1)}`);
        // } else {
        //   loadMoreBtnPrev.setAttribute("href", `${Pagination.GetRelativeUrl(1)}`);
        // }

        // Next
        let pageCount = Pagination.GetPageCount();

        if (Pages.IsFiltered()) {
          pageCount = Pagination.GetFilteredPageCount();
        }

        if (pageNext + 1 < pageCount) {
          loadMoreBtnNext.setAttribute("href", `${Pagination.GetRelativeUrl(pageNext + 1)}`);
        } else {
          loadMoreBtnNext.setAttribute("href", `${Pagination.GetRelativeUrl(pageCount)}`);
          loadMoreBtnNext.classList.add("sk-hidden");
        }

        if (DEBUG) {
          console.log(`Finished loading page ${pageNext} / ${Pagination.GetPageCount()}`);
        }
      }, 100);
    }
  }

  function LoadPrevCallback(e) {
    e.preventDefault();

    if (Pages.IsFiltered()) {
      // Get prev page
      let pagePrev = pageNumData.lowest - 1;

      // If none, return
      if (pagePrev < 1) {
        if (DEBUG) {
          console.warn("At first page, no load more");
        }

        return;
      }

      // Remove Products
      // RemoveAllProducts();

      // Hide collection
      loadMoreBtnPrev.classList.add("sk-hidden");
      loadMoreBtnNext.classList.add("sk-hidden");

      // loadMoreBtnPrev.setAttribute("href", `${Pagination.GetRelativeUrl(1)}`);
      // loadMoreBtnNext.setAttribute("href", `${Pagination.GetRelativeUrl(2)}`);

      // Load
      Loading.ShowTop();

      // Scroll to top
      // scrollTo({
      //   top: 0,
      //   left: 0,
      //   behavior: "auto",
      // });

      setTimeout(() => {
        // Add Page
        AddFilteredPageToTop(pagePrev, true);

        RemoveProductsOnPrevPageLoad(pagePrev);

        // Set page number to href
        // Prev
        if (pagePrev - 1 > 1) {
          loadMoreBtnPrev.setAttribute("href", `${Pagination.GetRelativeUrl(pagePrev - 1)}`);
        } else {
          loadMoreBtnPrev.setAttribute("href", `${Pagination.GetRelativeUrl(1)}`);
          loadMoreBtnPrev.classList.add("sk-hidden");
        }

        // Next
        // let pageCount = Pagination.GetPageCount();

        // if (Pages.IsFiltered()) {
        //   pageCount = Pagination.GetFilteredPageCount();
        // }

        // if (pagePrev + 1 < pageCount) {
        //   loadMoreBtnNext.setAttribute("href", `${Pagination.GetRelativeUrl(pagePrev + 1)}`);
        // } else {
        //   loadMoreBtnNext.setAttribute("href", `${Pagination.GetRelativeUrl(pageCount)}`);
        // }

        if (DEBUG) {
          console.log(`Finished loading page ${pagePrev} / ${Pagination.GetFilteredPageCount()}`);
        }
      }, 100);
    } else {
      // Get prev page
      let pagePrev = pageNumData.lowest - 1;

      // If none, return
      if (pagePrev < 1) {
        if (DEBUG) {
          console.warn("At first page, no load more");
        }

        return;
      }

      // Remove Products
      // RemoveAllProducts();

      // Hide collection
      loadMoreBtnPrev.classList.add("sk-hidden");
      loadMoreBtnNext.classList.add("sk-hidden");

      // loadMoreBtnPrev.setAttribute("href", `${Pagination.GetRelativeUrl(1)}`);
      // loadMoreBtnNext.setAttribute("href", `${Pagination.GetRelativeUrl(2)}`);

      // Load
      Loading.ShowTop();

      // Scroll to top
      // scrollTo({
      //   top: 0,
      //   left: 0,
      //   behavior: "auto",
      // });

      setTimeout(() => {
        // Add Page
        AddPageToTop(pagePrev, true);

        RemoveProductsOnPrevPageLoad(pagePrev);

        // Set page number to href
        // Prev
        if (pagePrev - 1 > 1) {
          loadMoreBtnPrev.setAttribute("href", `${Pagination.GetRelativeUrl(pagePrev - 1)}`);
        } else {
          loadMoreBtnPrev.setAttribute("href", `${Pagination.GetRelativeUrl(1)}`);
          loadMoreBtnPrev.classList.add("sk-hidden");
        }

        // Next
        // let pageCount = Pagination.GetPageCount();

        // if (Pages.IsFiltered()) {
        //   pageCount = Pagination.GetFilteredPageCount();
        // }

        // if (pagePrev + 1 < pageCount) {
        //   loadMoreBtnNext.setAttribute("href", `${Pagination.GetRelativeUrl(pagePrev + 1)}`);
        // } else {
        //   loadMoreBtnNext.setAttribute("href", `${Pagination.GetRelativeUrl(pageCount)}`);
        // }

        if (DEBUG) {
          console.log(`Finished loading page ${pagePrev} / ${Pagination.GetPageCount()}`);
        }
      }, 100);
    }
  }

  /**
   * - Load callback
   */
  /**
   * Removes products on previous page load if needed
   * - Tracks page count, lowest, highest, and max
   * - If max exceeded, remove page from bottom
   */
  function RemoveProductsOnPrevPageLoad(pageNum = undefined) {
    if (pageNum === undefined) return;

    if (pageNum < pageNumData.lowest) {
      pageNumData.lowest = pageNum;
    }

    pageNumData.total = pageNumData.highest - pageNumData.lowest;

    console.log("A", pageNumData.total, pageNumData.max, pageNumData.lowest, pageNumData.highest);

    while (pageNumData.total > pageNumData.max) {
      RemovePageFromBottom();

      console.log("B", pageNumData.total, pageNumData.max, pageNumData.lowest, pageNumData.highest);

      pageNumData.highest = pageNumData.highest - 1;
      pageNumData.total = pageNumData.highest - pageNumData.lowest;
    }
  }

  /**
   * Removes products on next page load if needed
   * - Tracks page count, lowest, highest, and max
   * - If max exceeded, remove page from top
   */
  function RemoveProductsOnNextPageLoad(pageNum = undefined) {
    if (pageNum === undefined) return;

    if (pageNum > pageNumData.highest) {
      pageNumData.highest = pageNum;
    }

    pageNumData.total = pageNumData.highest - pageNumData.lowest;

    console.log("A", pageNumData.total, pageNumData.max, pageNumData.lowest, pageNumData.highest);

    while (pageNumData.total > pageNumData.max) {
      RemovePageFromTop();

      console.log("B", pageNumData.total, pageNumData.max, pageNumData.lowest, pageNumData.highest);

      pageNumData.lowest = pageNumData.lowest + 1;

      if (pageNumData.lowest < 1) {
        pageNumData.lowest = 1;
      }

      pageNumData.total = pageNumData.highest - pageNumData.lowest;
    }
  }

  /* ===== Tracker ===== */
  function SetHighestPageLoadedNum(pageNum = 1) {
    highestFilteredPageLoadedNum = pageNum;
  }

  function SetHighestFilteredPageLoadedNum(pageNum = 1) {
    highestFilteredPageLoadedNum = pageNum;
  }

  function SetVisiblePageCount(pageCount = 1) {
    visiblePageCount = pageCount;

    if (pageCount === 0) {
      pageArray = [];
      filteredPageArray = [];
    }
  }

  /* ===== Populate Functions ===== */
  // - Add page
  async function AddPageToBottom(pageNum = 1, scrollToPrev = false) {
    return new Promise((resolve, reject) => {
      PageStateUtil.StartLoading("bottom");

      Pages.GetPage(pageNum)
      .then(page => {
        page.forEach(product => {
          productContainer.appendChild(product);
        });

        // Re-init the events on products
        ProductEventInit();

        // Update page number
        Pagination.SetCurrPageNum(pageNum);

        // Re-init load more
        LoadMoreInit();

        // Update product count
        productCountElem.innerText = Pagination.GetProductCount();

        // Stop loading
        PageStateUtil.StopLoadingAtPage();

        // Tracker
        addedToBottom = true;
        addedToTop = false;

        addToPageArray(pageNum);
        visiblePageCount = pageArray.length;

        if (scrollToPrev) {
          // Scroll to previous last product
          setTimeout(() => {
            let products = Array.from(document.querySelectorAll(".product-card"));
            let productToScrollTo = products[products.length - Pagination.GetProductCountPerPage()];

            scrollTo({
              top: productToScrollTo.offsetTop - productToScrollTo.offsetHeight,
              left: 0,
              behavior: "auto",
            });
          }, scrollBackDur);
        }

        resolve(true);
      })
      .catch(err => {
        resolve(false);
      });
    });
  }

  async function AddPageToTop(pageNum = 1, scrollToPrev = false, callback = undefined) {
    return new Promise((resolve, reject) => {
      PageStateUtil.StartLoading("top");

      Pages.GetPage(pageNum)
      .then(page => {
        let index = 0;
        let prevProduct = undefined;

        page.forEach(product => {
          if (index !== 0) {
            // Insert after previous product
            productContainer.insertBefore(product, prevProduct.nextSibling);
            prevProduct = product;
          } else {
            // Insert first product
            productContainer.insertBefore(product, productContainer.firstElementChild);
            prevProduct = product;
          }

          index++;
        });

        // Re-init the events on products
        ProductEventInit();

        // Update page number
        Pagination.SetCurrPageNum(pageNum);

        // Re-init load more
        LoadMoreInit();

        // Update product count
        productCountElem.innerText = Pagination.GetProductCount();

        // Stop loading
        PageStateUtil.StopLoadingAtPage();

        // Tracker
        addedToBottom = false;
        addedToTop = true;

        addToPageArray(pageNum);
        visiblePageCount = pageArray.length;

        if (scrollToPrev) {
          // Scroll to previous top product
          setTimeout(() => {
            let products = Array.from(document.querySelectorAll(".product-card"));
            let productToScrollTo = products[Pagination.GetProductCountPerPage() - 1];

            scrollTo({
              top: productToScrollTo.offsetTop,
              left: 0,
              behavior: "auto",
            });
          }, scrollBackDur);
        }

        if (callback !== undefined) {
          callback();
        }

        resolve(true);
      })
      .catch(err => {
        resolve(false);
      });
    });
  }

  // - Add filtered page
  async function AddFilteredPageToBottom(pageNum = 1, scrollToPrev = false) {
    return new Promise((resolve, reject) => {
      PageStateUtil.StartLoading("bottom");

      // Get page
      Pages.GetFilteredPage(pageNum)
      .then(page => {
        page.forEach(product => {
          productContainer.appendChild(product);
        });

        // Re-init the events on products
        ProductEventInit();

        // Update page number
        Pagination.SetFilteredCurrPageNum(pageNum);

        // Re-init load more
        LoadMoreInit();

        // Update product count
        productCountElem.innerText = Pagination.GetFilteredProductCount();

        // Stop Loading
        PageStateUtil.StopLoadingAtPage();

        // Tracker
        addedToBottom = true;
        addedToTop = false;

        addToFilteredPageArray(pageNum);
        visiblePageCount = filteredPageArray.length;

        if (scrollToPrev) {
          // Scroll to previous last product
          setTimeout(() => {
            let products = Array.from(document.querySelectorAll(".product-card"));
            let productToScrollTo = products[products.length - Pagination.GetProductCountPerPage()];

            scrollTo({
              top: productToScrollTo.offsetTop - productToScrollTo.offsetHeight,
              left: 0,
              behavior: "auto",
            });
          }, scrollBackDur);
        }

        resolve(true);
      })
      .catch(err => {
        resolve(false);
      });
    });
  }

  async function AddFilteredPageToTop(pageNum = 1, scrollToPrev = false) {
    return new Promise((resolve, reject) => {
      PageStateUtil.StartLoading("top");

      // Get page
      Pages.GetFilteredPage(pageNum)
      .then(page => {
        let index = 0;
        let prevProduct = undefined;

        page.forEach(product => {
          if (index !== 0) {
            // Insert after previous product
            productContainer.insertBefore(product, prevProduct.nextSibling);
            prevProduct = product;
          } else {
            // Insert first product
            productContainer.insertBefore(product, productContainer.firstElementChild);
            prevProduct = product;
          }

          index++;
        });

        // Re-init the events on products
        ProductEventInit();

        // Update page number
        Pagination.SetFilteredCurrPageNum(pageNum);

        // Re-init load more
        LoadMoreInit();

        // Update product count
        productCountElem.innerText = Pagination.GetFilteredProductCount();

        // Stop Loading
        PageStateUtil.StopLoadingAtPage();

        // Tracker
        addedToBottom = false;
        addedToTop = true;

        addToFilteredPageArray(pageNum);
        visiblePageCount = filteredPageArray.length;

        if (scrollToPrev) {
          // Scroll to previous top product
          setTimeout(() => {
            let products = Array.from(document.querySelectorAll(".product-card"));
            let productToScrollTo = products[Pagination.GetProductCountPerPage()];

            scrollTo({
              top: productToScrollTo.offsetTop,
              left: 0,
              behavior: "auto",
            });
          }, scrollBackDur);
        }

        resolve(true);
      })
      .catch(err => {
        resolve(false);
      });
    });
  }

  // - Remove products
  function RemovePageFromBottom() {
    // Local product count per page
    let productCount = 0;
    if (Pages.IsFiltered()) {
      Pages.GetFilteredPage(PageStateUtil.GetHighest()).then(page => {
        productCount = page.length;

        // Remove each product until a page has been removed
        for (let i = 0; i < productCount; i++) {
          if (productContainer.lastElementChild) {
            productContainer.lastElementChild.remove();
          }
        }
      });
    } else {
      Pages.GetPage(PageStateUtil.GetHighest()).then(page => {
        productCount = page.length;

        // Remove each product until a page has been removed
        for (let i = 0; i < productCount; i++) {
          if (productContainer.lastElementChild) {
            productContainer.lastElementChild.remove();
          }
        }
      });
    }

    // Tracker
    if (Pages.IsFiltered()) {
      removeLargestFromFilteredPageArray();
      visiblePageCount = filteredPageArray.length;
    } else {
      removeLargestFromPageArray();
      visiblePageCount = pageArray.length;
    }
  }

  function RemovePageFromTop() {
    // Local product count per page
    let productCount = 0;
    if (Pages.IsFiltered()) {
      Pages.GetFilteredPage(PageStateUtil.GetLowest()).then(page => {
        productCount = page.length;

        // Remove each product until a page has been removed
        for (let i = 0; i < productCount; i++) {
          if (productContainer.firstElementChild) {
            productContainer.firstElementChild.remove();
          }
        }
      });
    } else {
      Pages.GetPage(PageStateUtil.GetLowest()).then(page => {
        productCount = page.length;

        // Remove each product until a page has been removed
        for (let i = 0; i < productCount; i++) {
          if (productContainer.firstElementChild) {
            productContainer.firstElementChild.remove();
          }
        }
      });
    }

    // Tracker
    if (Pages.IsFiltered()) {
      removeSmallestFromFilteredPageArray();
      visiblePageCount = filteredPageArray.length;
    } else {
      removeSmallestFromPageArray();
      visiblePageCount = pageArray.length;
    }
  }

  function RemoveAllProducts() {
    // Hide collection
    productContainer.classList.add("sk-hidden");

    PageStateUtil.StartLoading("top");

    // Remove all products
    document.querySelectorAll(".product-card").forEach(item => {
      item.remove();
    });

    // Show collection
    productContainer.classList.remove("sk-hidden");

    PageStateUtil.StopLoadingAtPage(1);
    PageStateUtil.SetLowest(1);
    PageStateUtil.SetHighest(1);

    SetVisiblePageCount(0);
    pageArray = [];
    filteredPageArray = [];

    scrollTo(0, 0);
  }

  /* ===== Page Array ===== */
  function addToPageArray(num = 1) {
    pageArray.push(num);
    pageArray.sort(function(a, b) {
      return a - b;
    });
  }

  function removeSmallestFromPageArray() {
    pageArray.shift();
  }

  function removeLargestFromPageArray() {
    pageArray.pop();
  }

  /* ===== Filtered Page Array ===== */
  function addToFilteredPageArray(num = 1) {
    filteredPageArray.push(num);
    filteredPageArray.sort(function(a, b) {
      return a - b;
    });
  }

  function removeSmallestFromFilteredPageArray() {
    filteredPageArray.shift();
  }

  function removeLargestFromFilteredPageArray() {
    filteredPageArray.pop();
  }

  OnStart();

  /* ===== Freeze ===== */
  return Object.freeze({
    AddFilteredPageToBottom,
    AddFilteredPageToTop,
    AddPageToBottom,
    AddPageToTop,
    LoadMoreInit,
    RemoveAllProducts,
    RemovePageFromBottom,
    RemovePageFromTop,
    SetHighestPageLoadedNum,
    SetHighestFilteredPageLoadedNum,
    SetVisiblePageCount,
  });
})();

// On Load Filtering
let OnLoadFilter = () => {
  /**
   * Store current filters into session storage
   */
  function storeFiltersToSessionStorage() {
    let filterList = "";
    const currUrl = document.body.getAttribute("data-curr-url");

    try {
      filterList = activeFilters.toString();
    } catch (e) {
      console.warn("Could not find active filters", e);
    }

    sessionStorage.setItem("currFilters", filterList);
    sessionStorage.setItem("currUrl", currUrl);
  }

  /**
   * Filter by filters provided by session
   */
  async function addFiltersbySessionFilterList(filters = []) {
    try {
      let activeFilters = [];
    } catch (e) {
      console.warn("Active filters already exists", e);
    }

    document.querySelector('.mobile-all-filter-modal').classList.remove('active')

    pageNum = 1;

    let allProducts = document.querySelectorAll('.product-card')
    let titleContainer = document.querySelector('.main-collection-title')

    filters.forEach(tag => {
      // Check if is bundle
      if (tag.toLowerCase().includes("bundle")) {
        let originalUrl = window.location.href;
        let bundleUrl = tag;
        let newUrl = "";

        // if url already has a hash, remove it
        originalUrl = originalUrl.split("#")[0];

        // format
        bundleUrl = bundleUrl.toLowerCase();
        bundleUrl = bundleUrl.replaceAll(" ", "-");

        // create
        newUrl = originalUrl + "#" + bundleUrl;

        // Set url with bundle name
        history.replaceState(null, "", newUrl);
      } else if (tag.toLowerCase().includes("inci")) { // Check if is inci
        let originalUrl = window.location.href;
        let filterUrl = tag;
        let newUrl = "";

        // if url already has a hash, remove it
        originalUrl = originalUrl.split("#")[0];

        // format
        filterUrl = filterUrl.toLowerCase();
        filterUrl = filterUrl.replaceAll(" ", "-");

        // create
        newUrl = originalUrl + "#" + filterUrl;

        // Set url with bundle name
        history.replaceState(null, "", newUrl);
      }

      let filterContainers = document.querySelectorAll('.filter-container');

      if (!activeFilters.includes(tag)) {
        activeFilters.push(tag)

        let filterTitle = tag;

        if (tag == "Bundle A") {
          filterTitle = "BUY 3 SOCKS SAVE 25%";
        }

        removeFilterTemplate = `<div class='collection-filters' data-filter="${tag}"><a>${filterTitle}</a><svg width="9" height="9" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.6948 1.37769L1.08398 15.9885" stroke="#777" stroke-width="2"></path>
          <path d="M1.19482 1.526L15.8057 16.1368" stroke="#777" stroke-width="2"></path>
          </svg></div>`
        if (window.innerWidth <= 980) {
          if (filterContainers[1].innerHTML.includes("No filters")) {
            filterContainers[1].innerHTML = ''
          }
          filterContainers[1].innerHTML += removeFilterTemplate
        } else {
          document.querySelector('.filter-container').innerHTML += removeFilterTemplate
        }

        initCollectionFilters();
      }
    });

    storeFiltersToSessionStorage();

    let result = await Pages.AddFilterCallback();

    titleContainer.style.paddingBottom = "1px"

    if (activeFilters.length > 0) {
      document.querySelector('.mobile-all-filter-modal').classList.add('has-filters')
    }
  }

  /**
   * Syncs filters to session storage
   */
  function syncToSession() {
    // Get session storage data
    let sessionFilterList = sessionStorage.getItem("currFilters");
    const sessionCurrUrl = sessionStorage.getItem("currUrl");

    // Get url to see if bundle exists
    const url = window.location.href;

    if (url.includes("#")) {
      let hash = url.split("#")[1];

      if (hash !== "" && hash.includes("bundle")) {
        let hashSplit = hash.split("-");

        for (let i = 0; i < hashSplit.length; i++) {
          hashSplit[i] = hashSplit[i].charAt(0).toUpperCase() + hashSplit[i].slice(1);
        }

        let bundleName = hashSplit.join(" ");

        if (sessionFilterList === null || sessionFilterList === "") {
          sessionFilterList = bundleName;
        } else {
          if (!sessionFilterList.includes(bundleName)) {
            sessionFilterList.concat(",", bundleName);
          }
        }
      } else if (hash !== "") {
        // Check if hash exists as a filter before adding it
        let collTags = document.querySelector("[data-coll-tags]").getAttribute("data-coll-tags").split(",");

        if (collTags.find(tag => tag.split(":")[1] === hash) === false) {
          return;
        }

        let hashSplit = hash.split("-");

        for (let i = 0; i < hashSplit.length; i++) {
          hashSplit[i] = hashSplit[i].charAt(0).toUpperCase() + hashSplit[i].slice(1);
        }

        let filterName = hashSplit.join(" ");

        if (sessionFilterList === null || sessionFilterList === "") {
          sessionFilterList = filterName;
        } else {
          if (!sessionFilterList.includes(filterName)) {
            sessionFilterList.concat(",", filterName);
          }
        }
      }
    }

    // Return if none found
    if (sessionFilterList === null || sessionFilterList === "" ||
        sessionCurrUrl === null || sessionCurrUrl === "") {
      return false;
    }

    // Get current session data
    const currUrl = document.body.getAttribute("data-curr-url");
    const filterList = sessionFilterList.split(",");
    const isCollectionPage = currUrl.includes("/collections/");
    const isSamePage = sessionCurrUrl === currUrl;

    // Filter if matches requirements
    if (filterList.length > 0 && isCollectionPage && isSamePage) {
      // Filter
      addFiltersbySessionFilterList(filterList);
    } else {
      // Clear
      sessionStorage.setItem("currFilters", "");
      sessionStorage.setItem("currUrl", "");
    }
  }

  return Object.freeze({
    addFiltersbySessionFilterList,
    storeFiltersToSessionStorage,
    syncToSession,
  });
}

// Init on page load
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    OnLoadFilter = OnLoadFilter();
    OnLoadFilter.syncToSession();
  });
} else {
  OnLoadFilter = OnLoadFilter();
  OnLoadFilter.syncToSession();
}

async function newAddFilter(e) {
  e = e.currentTarget;

  if (Loading.IsLoading()) {
    return;
  }

  document.querySelector('.mobile-all-filter-modal').classList.remove('active')

  // Check if is bundle
  if (e.hasAttribute("data-is-bundle") && e.getAttribute("data-is-bundle") === "true") {
    let originalUrl = window.location.href;
    let bundleUrl = e.getAttribute("data-category-filter");
    let newUrl = "";

    // if url already has a hash, remove it
    originalUrl = originalUrl.split("#")[0];

    // format
    bundleUrl = bundleUrl.toLowerCase();
    bundleUrl = bundleUrl.replaceAll(" ", "-");

    // create
    newUrl = originalUrl + "#" + bundleUrl;

    // Set url with bundle name
    history.replaceState(null, "", newUrl);
  } else if (e.hasAttribute("data-is-inci") && e.getAttribute("data-is-inci") === "true") { // Check if is inci
    let originalUrl = window.location.href;
    let filterUrl = e.getAttribute("data-category-filter");
    let newUrl = "";

    // if url already has a hash, remove it
    originalUrl = originalUrl.split("#")[0];

    // format
    filterUrl = filterUrl.toLowerCase();
    filterUrl = filterUrl.replaceAll(" ", "-");

    // create
    newUrl = originalUrl + "#" + filterUrl;

    // Set url with bundle name
    history.replaceState(null, "", newUrl);
  }

  pageNum = 1;

  let tag = e.dataset.categoryFilter
  let allProducts = document.querySelectorAll('.product-card')
  let titleContainer = document.querySelector('.main-collection-title')

  let filterContainers = document.querySelectorAll('.filter-container');

  if (!activeFilters.includes(tag)) {
    activeFilters.push(tag)

    let filterTitle = tag;

    if (tag == "Bundle A") {
      filterTitle = "BUY 3 SOCKS SAVE 25%";
    }

    removeFilterTemplate = `<div class='collection-filters' data-filter="${tag}"><a>${filterTitle}</a><svg width="9" height="9" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.6948 1.37769L1.08398 15.9885" stroke="#777" stroke-width="2"></path>
      <path d="M1.19482 1.526L15.8057 16.1368" stroke="#777" stroke-width="2"></path>
      </svg></div>`
    if (window.innerWidth <= 980) {
      if (filterContainers[1].innerHTML.includes("No filters")) {
        filterContainers[1].innerHTML = ''
      }
      filterContainers[1].innerHTML += removeFilterTemplate
    } else {
      document.querySelector('.filter-container').innerHTML += removeFilterTemplate
    }

    initCollectionFilters();
  }

  OnLoadFilter.storeFiltersToSessionStorage();

  let result = await Pages.AddFilterCallback();

  titleContainer.style.paddingBottom = "1px"

  if (activeFilters.length > 0) {
    document.querySelector('.mobile-all-filter-modal').classList.add('has-filters')
  }
}

async function newRemoveFilter(e) {
  e = e.currentTarget;

  if (Loading.IsLoading()) {
    return;
  }

  document.querySelector('.mobile-all-filter-modal').classList.remove('active')

  // clear hash on removal
  let originalUrl = window.location.href;

  // if url already has a hash, remove it
  originalUrl = originalUrl.split("#")[0];

  // Set url to url without hash
  history.replaceState(null, "", originalUrl);

  let tag = e.dataset.filter

  activeFilters.forEach((filter, i) => {
    if (filter == tag) {
      activeFilters.splice(i, 1);
      e.remove()
    }
  })

  OnLoadFilter.storeFiltersToSessionStorage()

  let result = await Pages.RemoveFilterCallback();
}

async function mobileClearAllFilters() {
  let filterContainer = document.querySelectorAll('.filter-container')[1]
  let filters = document.querySelectorAll('.collection-filters')

  filters.forEach(filter => filter.remove())
  filterContainer.innerHTML = "No filters selected"
  activeFilters = []

  OnLoadFilter.storeFiltersToSessionStorage()

  let result = await Pages.RemoveFilterCallback();
}

// Mobile modal functionality
document.addEventListener("click", e => {
  let element = e.target

  document.querySelector('.mobile-sort-by-modal').classList.remove('active')
  document.querySelector('.mobile-sort-by-background').classList.remove('active')

  if (element.classList.contains('mobile-all-filter-title')) {
    element.closest('.mobile-all-filter').querySelector('.mobile-all-filter-modal').classList.add('active')
  } else if (element.classList.contains('mobile-sort-by-title')) {
      element.closest('.mobile-sort-by').querySelector('.mobile-sort-by-modal').classList.add('active')
      element.closest('.mobile-sort-by').querySelector('.mobile-sort-by-background').classList.add('active')
  }

  // close all filters modal
  if (element.classList.contains('all-filter-modal-close') || element.closest('.all-filter-modal-close')) {
    document.querySelector('.mobile-all-filter-modal').classList.remove('active')
  }

  // opens filters on categories
  if (element.closest('.all-filter-modal-main') && !element.dataset.categoryFilter) {
    let filterMain = element.closest('.all-filter-modal-main').querySelector('.all-filters');
    let filterMainTitle = element.closest('.all-filter-modal-main').querySelector('.all-filter-modal-main-title').querySelector('span');

    if (element.closest('.all-filter-modal-main').querySelector('.all-filters').classList.contains('active')) {
      filterMain.classList.remove('active')
      filterMainTitle.style.transform = "rotate(180deg)"
    } else {
      filterMain.classList.add('active')
      filterMainTitle.style.transform = "rotate(0)"
    }
  }
})

function openMobileVariantSelector(e) {
  e = e.currentTarget;
  e.closest('.mobile-variant-picker').classList.add('active')
}
function closeMobileVariantSelector(e) {
  e = e.currentTarget;
  let mobileVariantPicker = e.closest('.mobile-variant-picker');

  if (mobileVariantPicker) {
    mobileVariantPicker.classList.remove('active');
  }

  mobileDeselectProduct()
}
function mobileSelectProduct(e) {
  e = e.currentTarget;
  e.closest('.variant-picker-main-options').classList.add('variant-selected')
  e.classList.add('selected-variant')

  let variantId = e.dataset.variantId
  let quantity = e.dataset.quantity
  let price = e.dataset.variantPrice
  let originalPrice = e.dataset.comparePrice

  let addToCartBtn = e.closest('.variant-picker-main').querySelector('.add-to-cart-btn');

  addToCartBtn.classList.remove('inactive')
  addToCartBtn.dataset.variantId = variantId
  addToCartBtn.dataset.quantity = quantity

  // data for notification popup
  let variantTitle = e.dataset.variantTitle;
  let imageSrc = e.dataset.src;
  let url = e.dataset.url;
  let notifComparePrice = e.dataset.notifComparePrice;
  let notifPrice = e.dataset.notifPrice;
  let quantityMax = e.dataset.quantityMax;
  let isBogo = e.dataset.isBogo;

  addToCartBtn.dataset.url = url;
  addToCartBtn.dataset.src = imageSrc;
  addToCartBtn.dataset.variantTitle = variantTitle;
  addToCartBtn.dataset.notifComparePrice = notifComparePrice;
  addToCartBtn.dataset.notifPrice = notifPrice;
  addToCartBtn.dataset.quantityMax = quantityMax;
  addToCartBtn.dataset.isBogo = isBogo;

  if (originalPrice) {
    addToCartBtn.innerHTML = `ADD ${price}&nbsp;<span class="strikethrough">${originalPrice}</span>`
  } else {
    addToCartBtn.innerHTML = `ADD ${price}`
  }
}
function mobileDeselectProduct() {
  document.querySelectorAll('.variant-selected').forEach(element => element.classList.remove('variant-selected'))
  document.querySelectorAll('.selected-variant').forEach(element => element.classList.remove('selected-variant'))
  document.querySelectorAll('.variant-picker-main').forEach(element => {
    let addToCartBtn = element.querySelector('.add-to-cart-btn');

    addToCartBtn.removeEventListener("click", showNotifyMeModal);
    addToCartBtn.classList.add('inactive')
    addToCartBtn.dataset.variantId = ''
    addToCartBtn.dataset.quantity = ''

    // notification popup
    addToCartBtn.dataset.url = ''
    addToCartBtn.dataset.src = ''
    addToCartBtn.dataset.variantTitle = ''
    addToCartBtn.dataset.notifComparePrice = ''
    addToCartBtn.dataset.notifPrice = ''
    addToCartBtn.dataset.quantityMax = ''
    addToCartBtn.dataset.isBogo = ''
  })
}

//adds SEE MORE button if scrollHeight > clientHeight
function addSeeMoreButton() {
  let description = document.querySelector(".products .description p");

  if (description) {
    let scrollHeight = description.scrollHeight
    let clientHeight = description.clientHeight

    if (Math.abs(scrollHeight - clientHeight) > 0) {
      let seeMoreBtn = document.querySelector(".products .description .see-more");

      if (seeMoreBtn) {
        seeMoreBtn.addEventListener("click", expandDescription);
      }

      seeMoreBtn.style.display = 'block'
    }
  }
}
addSeeMoreButton()
function expandDescription(e) {
  e = e.currentTarget;
  document.querySelector('.description p').style.height = "auto"
  document.querySelector('.description p').style.display = "inline"
  e.remove()
}

// Init
function initCollectionFilters() {
  Array.from(document.querySelectorAll(".main-collection-left-side ul.side-linklist li.side-link a[data-category-filter]")).forEach(link => {
    link.addEventListener("click", newAddFilter);
  });

  let seeMoreBtn = document.querySelector(".products .description .see-more");

  if (seeMoreBtn) {
    seeMoreBtn.addEventListener("click", expandDescription);
  }

  document.querySelector(".mobile-filters .mobile-all-filter .mobile-clear-filters").addEventListener("click", mobileClearAllFilters);

  Array.from(document.querySelectorAll(".mobile-filters .mobile-all-filter .all-filters li a[data-category-filter]")).forEach(link => {
    link.addEventListener("click", newAddFilter);
  });

  Array.from(document.querySelectorAll(".main-collection-right-side ul.side-linklist li.side-link a[data-category-filter]")).forEach(link => {
    link.addEventListener("click", newAddFilter);
  });

  Array.from(document.querySelectorAll(".filter-container div.collection-filters[data-filter]")).forEach(filter => {
    filter.addEventListener("click", newRemoveFilter);
  });
}

initCollectionFilters();

function initCollectionProducts() {
  let allProducts = Array.from(document.querySelectorAll(".product-card"));
  // desktop
  allProducts.forEach(product => {
    product.addEventListener("mouseenter", openVariantOverlay);
  });

  allProducts.forEach(product => {
    product.addEventListener("mouseleave", closeAllOverlays);
  });

  Array.from(document.querySelectorAll(".product-card .base-product .button-container .add-to-cart-btn.scroller-button")).forEach(btn => {
    btn.addEventListener("click", openScroller);
  });

  Array.from(document.querySelectorAll(".product-card .base-product .button-container .add-to-cart-btn.overlay-button")).forEach(btn => {
    btn.addEventListener("click", addToCart);
  });

  Array.from(document.querySelectorAll(".product-card .variant-scroller .variant-scroller-back")).forEach(scroller => {
    scroller.addEventListener("click", closeResetScrollers);
  });

  Array.from(document.querySelectorAll(".product-card .variant-scroller .variant-scroller-option:not(.unavailable)")).forEach(option => {
    option.addEventListener("click", selectProduct);
  });

  Array.from(document.querySelectorAll(".product-card .variant-scroller .add-to-cart-btn")).forEach(btn => {
    btn.addEventListener("click", addToCart);
  });

  // mobile
  Array.from(document.querySelectorAll(".mobile-variant-picker.bottom .variant-picker-background")).forEach(bg => {
    bg.addEventListener("click", closeMobileVariantSelector);
  });

  Array.from(document.querySelectorAll(".mobile-variant-picker.bottom .variant-picker-close")).forEach(btn => {
    btn.addEventListener("click", closeMobileVariantSelector);
  });

  Array.from(document.querySelectorAll(".mobile-variant-picker.bottom .variant-picker-deselect")).forEach(deselector => {
    deselector.addEventListener("click", mobileDeselectProduct);
  });

  Array.from(document.querySelectorAll(".mobile-variant-picker.bottom .variant-picker-selector")).forEach(selector => {
    selector.addEventListener("click", openMobileVariantSelector);
  });

  Array.from(document.querySelectorAll(".mobile-variant-picker.bottom .add-to-cart-btn")).forEach(btn => {
    btn.addEventListener("click", addToCart);
  });

  Array.from(document.querySelectorAll(".mobile-variant-picker.bottom .variant-picker-main-option:not(.unavailable)")).forEach(option => {
    option.addEventListener("click", mobileSelectProduct);
  });

  Array.from(document.querySelectorAll(".mobile-variant-picker.bottom .variant-picker-basic")).forEach(btn => {
    btn.addEventListener("click", addToCart);
  });

  initSoldOutMobileBtns();

  loadReviews();
}

initCollectionProducts();


/*
    Breadcrumbs Update 2023 Mar 23
*/
function addEllipsisToBreadcrumbs() {
  // ellipsis solution
  let breadcrumbs = document.querySelector(".global-breadcrumbs");
  let bcWidth = breadcrumbs.getBoundingClientRect().width;
  let lastBreadcrumb = document.querySelector(".global-breadcrumbs p");

  let extraPadding = 26;
  let lrPadding = 26;

  lastBreadcrumb.style = `max-width: calc(100vw - ${lrPadding}px - ${lrPadding}px - ${extraPadding}px);`;
}

addEllipsisToBreadcrumbs();


/*
  Init Accordion for side menus
*/
const SideMenus = (() => {
  function showAccordion(title = undefined) {
    let sideTitle = title;
    let sideList = sideTitle.nextElementSibling;

    sideTitle.classList.remove("deactivated");
    sideList.style = `margin-bottom: 24px; opacity: 1; max-height: ${sideList.scrollHeight}px;`;
  }

  function hideAccordion(title = undefined) {
    let sideTitle = title;
    let sideList = sideTitle.nextElementSibling;

    sideTitle.classList.add("deactivated");
    let activeListItem = Array.from(sideList.querySelectorAll(".active"));
    let activeListHeight = 0;
    let heightPadding = 7;

    activeListItem.forEach(item => activeListHeight += item.scrollHeight);

    if (activeListItem.length > 0) {
      sideList.style = `max-height: ${activeListHeight + heightPadding}px; margin-bottom: 12px;`;
    } else {
      sideList.style = "max-height: 0; margin-bottom: 12px;";
    }
  }

  function toggleAccordion(e = undefined) {
    if (e) e.preventDefault();

    let sideTitle = e.currentTarget;

    if (sideTitle.classList.contains("deactivated")) {
      showAccordion(sideTitle);
    } else {
      hideAccordion(sideTitle);
    }
  }

  function init() {
    let sideListTitles = Array.from(document.querySelectorAll("p.side-title"));

    sideListTitles.forEach(title => {
      title.addEventListener("click", toggleAccordion);

      if (!title.classList.contains("deactivated")) title.nextElementSibling.style = `margin-bottom: 24px; opacity: 1; max-height: ${title.nextElementSibling.scrollHeight}px;`;
    });

    window.addEventListener("resize", init);
  }

  return Object.freeze({
    init,
  });
})();

setTimeout(() => {
  SideMenus.init();
}, 100);
